import React, { useState, useEffect, useRef, useContext, memo, useCallback, useMemo } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
    Modal,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tab,
    Tabs,
    Tooltip,
    IconButton,
    Avatar,
    Box,
    Stack,
    TextField,
    Autocomplete,
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
} from "@mui/material";

import Badge from "@mui/material/Badge";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ServiceRequestLogIcon from "@mui/icons-material/Article";
import SubjectIcon from "@mui/icons-material/Subject";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";

import CrudService from "services/cruds-service";
import { ParamValuesChartForHolyKel } from "../ParamChart";
import DataTable from "examples/Tables/DataTable";
import ServiceRequestDataTable from "examples/Tables/ServiceRequestDataTable";
import moment from "moment";
import CollapsibleTable from "examples/Tables/ExpandTable";
import AlertRulesForm from "../alertrule/new";
import ServiceRequestsForm from "../service-request/new";
import ServiceRequestStatusLogForm from "../service-request/log";
import CalibrateDeviceForm from "../calibrate-device";
import DeviceDisconnectForm from "../disconnect-device";
import MultiSeviceRequestStatusEditForm from "../service-request/multiStatusEdit";
import MDAlert from "components/MDAlert";
import GoogleMapComponent from "examples/Maps";
import { useMediaQuery } from "react-responsive";
import { Can } from "Can";
import breakpoints from "assets/theme/base/breakpoints";
import { useWebSocket } from "context/WebSocketContext";
import Thresholds from "../../thresolds";
import { validateInput } from "utils/constant";
import { toast } from "react-toastify";
import JsonTree from "cruds/campaign/modal/jsontree";
import FormField from "layouts/applications/wizard/components/FormField";
import { deviceSetupShapes } from "utils/constant";
import { show_device_setting } from "utils/constant";
import UpdateDeviceSettings from "../../update_device_settings";
import Visibility from '@mui/icons-material/Visibility';
import { fieldMapping } from "utils/constant";
import ContactDeviceAccess from "../../contact_device_access";
import { serviceRequestStatusColor } from "utils/constant";
import { AuthContext } from "context";
import MDDatePicker from "components/MDDatePicker";
import {
    calculateFullDate,
    capitalizeWords,
    cond,
    deepCopy,
    deviceFields,
    formatNumber,
    formatValue,
    getKeyWithSpecialValue
} from './utils';
import { } from './services';
import {
    DynamicDataTable,
    RenderTR,
    StackSkeleton,
    StyledBadge,
    StyledProgress,
    TableSection,
    devStyle,
} from './misc';
import MDInput from "components/MDInput";
import LogsTable from "../table-view/logsTable";
import EventsTable from "../table-view/eventsTable";
import ParamType from "../ParamType";
import {
    ChannelOverview,
    ChannelDetailCard,
    getInitialChannel,
    nestedSurfaceSx,
    normalizeChannels,
    useChannelUrlSync,
} from "../gateway-channels";
import LinkedDeviceView from "../LinkedDeviceView";
import Chip from "@mui/material/Chip";
import LinkedVehicleCard, { LINKED_VEHICLE_SECTION_ID } from "../linked-vehicle/LinkedVehicleCard";
import useLinkedVehicles from "../linked-vehicle/useLinkedVehicles";
import JobsTable from "../table-view/jobsTable";
import {
    formatUllageHeight,
    formatUllageVolume,
    getUllageStateText,
    isUllageApplicable,
} from "utils/ullage";

const HolyKelDevice = ({ channels = [], default_channel = '1' }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const serviceRequestSelectedTab = localStorage.getItem("serviceRequestTab");

    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const [paramValues, setParamValues] = useState([]);
    const [percent, setPercent] = useState(0);
    const [paramValue, setParamValue] = useState();
    const [device, setDevice] = useState();
    const [tableData, setTableData] = useState([]);
    const [serviceStatusUpdate, setServiceStatusUpdate] = useState("");
    const [serviceRequestId, setServiceRequestId] = useState("");
    const [logServiceRequestId, setLogServiceRequestId] = useState("");
    const [deviceStatusName, setDeviceStatusName] = useState("");
    const [calibrateDeviceModal, setCalibrateDeviceModal] = useState(false);
    const [deviceDisconnectModal, setDeviceDisconnectModal] = useState(false);
    const [expandedIndexArray, setExpandedIndexArray] = useState([
        true,
        true,
        true,
        ...Array(6).fill(false),
    ]);
    const [isNotified, setNotified] = useState(false);
    const [isShare, setShare] = useState(false);
    const [selectedTab, setSelectedTab] = useState(
        parseInt(serviceRequestSelectedTab)
    );

    const [openViewModal, setOpenViewModal] = useState(false);
    const [serviceRequestLogModal, setServiceRequestLogModal] = useState(false);
    const [alert, setAlert] = useState();
    const [alertTableData, setAlertTableData] = useState([]);

    const [alertRule, setAlertRule] = useState([]);
    const [alertRules, setAlertRules] = useState([]);
    const [eventTableData, setEventTableData] = useState([]);
    const [serviceRequests, setServiceRequests] = useState([]);
    const [serviceRequest, setServiceRequest] = useState([]);
    const [alertRuleTableData, setAlertRuleTableData] = useState([]);
    const [serviceRequestTableData, setServiceRequestTableData] = useState([]);

    /////////// service request ////////////
    const [openServiceModal, setServiceModal] = useState(false);
    const [serviceRequestEditFlag, setServiceRequestEditFlag] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [checkRowSelectedRowsFlag, setCheckSelectedRowsFlag] = useState(false);
    const [selectedRowsIdArray, setSelectedRowsIdArray] = useState([]);
    const [multiStatusEditModal, setMultiStatusEditModal] = useState(false);
    const [dataTableUpdate, setDataTableUpdate] = useState("");
    const [selectedRequestType, setSelectedRequestType] = useState("");
    const [serviceRequestDeleteFlag, setServiceRequestDeleteFlag] =
        useState(false);

    const [notification, setNotification] = useState({
        value: false,
        text: "",
    });

    const [pillbarColor, setPillbarColor] = useState("rgb(38, 40, 51);");
    const [providersState, setProvidersState] = useState([]);
    const [activeAlerts, setActiveAlerts] = useState([]);
    const [activeServiceRequest, setActiveServiceRequest] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [phoneEnvModal, setPhoneEnvModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [phoneEnv, setPhoneEnv] = useState({
        is_production: false,
        is_sandbox: false,
        is_development: true,
    });
    const [gps, setGps] = useState({ latitude: "", longitude: "", edit: false });
    const [deviceUpdated, setDeviceUpdated] = useState("");
    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const [reportType, setReportType] = useState({});
    const [wsEmit, setEmit] = useState(1);
    ////////////////// Device Thresholds /////////////////////
    const [openMonitorEditModal, setOpenMonitorEditModal] = useState(false);
    const [selectedThresholds, setSelectedThresholds] = useState([]);
    const [selectedChannelThresholds, setSelectedChannelThresholds] = useState([]);

    ///////////////// contact addresss ////////////////
    const [openContactDetailsEditModal, setOpenContactDetailsEditModal] =
        useState(false);

    const [openDeviceInfoEditModal, setOpenDeviceInfoEditModal] = useState(false);
    ///////////////// Device Setup ////////////////
    const [openDeviceSetupEditModal, setOpenDeviceSetupEditModal] = useState(false);
    const [openDeviceSettingModal, setOpenDeviceSettingModal] = useState(false);
    const [deviceSetupFields, setDeviceSetupFields] = useState(deepCopy(deviceFields));
    const [originalDeviceSetupFields, setOriginalDeviceSetupFields] = useState(deepCopy(deviceFields));
    const [navbarTitle, setNavbarTitle] = useState("");
    const [titleIcon, setTitleIcon] = useState(null)
    const [selectedIcon, setSelectedIcon] = useState(null)
    const [deviceName, setDeviceName] = useState(null)
    const [openJsonTree, setJsonTree] = useState(false)
    const [rawDataValue, setRawDataValue] = useState({})
    const [requiredThresholds, setRequiredThresholds] = useState([])
    const [isAttributeRequired, setIsAttributeRequired] = useState(false)
    const [iconList, setIconList] = useState([])
    const [modelist, setModeList] = useState([])
    const [selectedMode, setSelectedMode] = useState(null)
    const [mapIdentifier, setMapIdentifier] = useState(null)
    const [parameters, setParameter] = useState([])
    const [identifierValue, setIdentifierValue] = useState(null)
    const [selectedLogInfo, setSelectedLogInfo] = useState(null)
    const { serviceRequestData, alertData, holyKelData, jobState } = useWebSocket();
    const authContext = useContext(AuthContext)
    const selectedContactDeviceAccess = useRef([])
    const [notifyAlert, setNotifyAlert] = useState(null)
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const countRef = useRef(0);
    const [deviceLogModel, setDeviceLogModel] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);
    const [pagin, setpagin] = useState([1, 100]);
    const [defaultChannel, setDefaultChannel] = useState(() => getInitialChannel(channels, default_channel));
    const [viewMode, setViewMode] = useState("classic");
    const overviewEnabled = viewMode === "overview";
    const [channelFilter, setChannelFilter] = useState("all");
    const deviceViewRef = useRef(null);
    const latestDeviceValueRef = useRef(null);
    const defaultChannelRef = useRef(defaultChannel);
    const appliedChannelRef = useRef(null);
    const channelScopeTokenRef = useRef(0);
    defaultChannelRef.current = defaultChannel;
    const [analysisData, setAnalysisData] = useState(null);
    const [isStateAvail, setIsStateAvail] = useState(false)
    const [isPressure, setIsPressure] = useState(false)
    const [channelEntity, setChannelEntity] = useState(null)
    const [jobStateData, setJobStateData] = useState(null)
    const [linkedDeviceData, setLinkedDeviceData] = useState([])
    const linkedVehicles = useLinkedVehicles(linkedDeviceData);
    const [selectedLinkedVehicleId, setSelectedLinkedVehicleId] = useState(null);
    const mappableVehicleIds = useMemo(
        () => new Set(linkedVehicles.map((vehicle) => vehicle.id)),
        [linkedVehicles]
    );

    const showLinkedVehicleOnMap = useCallback((deviceId) => {
        setSelectedLinkedVehicleId(String(deviceId));
        document
            .getElementById(LINKED_VEHICLE_SECTION_ID)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, []);

    const memoizedParam = React.useMemo(
        () => paramValue,
        [paramValue]
    )

    const channelModels = useMemo(
        () =>
            normalizeChannels({
                channelsList: channels,
                liveChannels: paramValue?.channels,
                thresholds: device?.deviceThresholds,
                paramValues,
                analysisData,
                alertsByChannel: { [String(defaultChannel)]: activeAlerts ?? [] },
            }),
        [channels, paramValue, device?.deviceThresholds, paramValues, analysisData, defaultChannel, activeAlerts]
    );

    const selectedChannelModel =
        channelModels.find((channel) => channel.key === String(defaultChannel)) ??
        channelModels[0] ??
        null;

    const handleSelectChannel = useCallback((channelNo) => setDefaultChannel(channelNo), []);

    // Keyboard switching and ?channel= URL writes only run while the opt-in overview is active,
    // so the classic view keeps its existing behavior.
    const { step: stepChannel } = useChannelUrlSync({
        channelNumbers: channelModels.map((channel) => channel.number),
        value: defaultChannel,
        onChange: handleSelectChannel,
        enableKeyboard: overviewEnabled,
        syncUrl: overviewEnabled,
    });

    const handleOverviewSelect = useCallback((channelNo) => {
        setDefaultChannel(channelNo);
        requestAnimationFrame(() => {
            const detail = document.getElementById("gateway-channel-detail");
            if (!detail) return;
            const rect = detail.getBoundingClientRect();
            if (rect.top > window.innerHeight * 0.6 || rect.bottom < 0) {
                detail.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        });
    }, []);


    useEffect(() => {
        if (id && holyKelData) {
            if (holyKelData.device_id == id) {
                updateDevice(holyKelData.data)
            }
        }
    }, [id, holyKelData]);

    useEffect(() => {
        if (id && jobState) {
            if (jobState?.device_id == id) {
                setJobStateData({
                    // data: jobState?.dataValues,
                    from_state: jobState.to_state,
                    to_state: jobState.to_state,
                    reason: jobState.reason,
                    timestamp: jobState.timestamp,
                    duration: jobState?.total_duration_seconds
                })
            }
        }
    }, [id, jobState]);

    useEffect(() => {
        if (id && alertData) {
            if (alertData.device_id == id) {
                // setEmit(() => Math.random() * 10);
                updateAlert(alertData.alert, alertData.type)
            }
        }
    }, [id, alertData]);

    useEffect(() => {
        if (id && serviceRequestData) {
            if (serviceRequestData.device_id == id) {
                checkActiveServiceRequest();
            }
        }
    }, [id, serviceRequestData]);

    // Recompute every channel-scoped piece of state from data that is already loaded.
    // Returns the paramValue record for the channel (or null when there is no webhook data).
    function applyChannelScope(data, channelNo, deviceValue) {
        const channelKey = String(channelNo);

        // Thresholds for this channel (edit modal + Monitor card)
        const channelBsThreshold = (data?.deviceThresholds ?? []).filter(
            (e) => String(e.channel_number) === channelKey
        );
        setSelectedChannelThresholds(channelBsThreshold);
        setSelectedThresholds(
            channelBsThreshold.map((threshold) => ({
                ...threshold,
                label: threshold?.DeviceParameter?.parameter_name,
                parameter_name: threshold?.DeviceParameter?.parameter_name,
                is_threshold_required: threshold?.DeviceParameter?.is_threshold_required,
                field_type_id: threshold?.DeviceParameter?.field_type_id,
                MessageTemplate: { attributes: threshold?.MessageTemplate },
            }))
        );

        // Channel entity + device setup fields
        const defChannel = channels.find((e) => String(e.channel_number) === channelKey);
        setChannelEntity(defChannel?.address_item ?? null);
        let setupFields = {};
        if (data?.itemAttributeValues || defChannel?.address_item) {
            const attribute = defChannel?.address_item?.ItemAttributeValues ?? data?.itemAttributeValues ?? [];
            setupFields = attribute.reduce((acc, item) => {
                const fieldName = fieldMapping[item.attribute_id];
                if (fieldName) acc[fieldName] = item.value;
                return acc;
            }, {});
            const isRequired = Object.entries(setupFields)
                .filter((e) => !["latitude", "longitude"].includes(e[0]))
                .some((e) => e[1] == "");
            setIsAttributeRequired(isRequired);
            setDeviceSetupFields(setupFields);
            setOriginalDeviceSetupFields(setupFields);
        }

        if (!deviceValue) {
            setIsStateAvail(false);
            setIsPressure(false);
            return null;
        }

        const liveChannel = deviceValue?.channels?.[channelNo] ?? deviceValue?.channels?.[channelKey];
        setIsStateAvail(!!liveChannel?.state);
        setIsPressure(liveChannel?.state?.channel_type === "pressure");

        const lastRecord = { data: liveChannel, ...deviceValue, device_setup: setupFields };
        setParamValue(lastRecord);
        setPercent(liveChannel?.current_value ?? liveChannel?.fill_percentage ?? 0);
        localStorage.setItem("device_params", JSON.stringify(lastRecord));

        // Legacy pillbar color (kept for any remaining consumers): red when a type 1/26 threshold is crossed.
        const parameterMapping = {
            percent_level: "percent_level",
            Temperature: "enclosure_temperature",
            product_level: "inch_level",
            measured_height: "measured_height",
        };
        let color = "rgb(38, 40, 51);";
        for (const t of channelBsThreshold) {
            if (![1, 26].includes(t.threshold_type_id)) continue;
            const propertyKey = parameterMapping[t?.DeviceParameter?.parameter_name];
            if (propertyKey === undefined) continue; // previously `return` here aborted the whole fetch
            const v = parseInt(lastRecord?.device_data?.[propertyKey]);
            const target = parseInt(t.threshold_value);
            const crossed = {
                1: v === target,
                2: v !== target,
                3: v < target,
                4: v <= target,
                5: v > target,
                6: v >= target,
            }[parseInt(t.comparison_operator_id)];
            if (crossed) color = "#d32f2f";
        }
        setPillbarColor(color);

        return lastRecord;
    }

    // Loads active alerts for one channel; ignores late responses after a newer channel switch.
    async function refreshChannelAlerts(channelNo) {
        const token = ++channelScopeTokenRef.current;
        try {
            const res = await CrudService.getDeviceActiveAlerts(id, channelNo);
            if (token !== channelScopeTokenRef.current) return [];
            const alertData = res?.data?.alerts?.reverse() ?? [];
            setActiveAlerts(alertData);
            if (alertData.length > 0) {
                setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex);
            }
            return alertData;
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    useEffect(() => {
        if (!id) return;
        setPillbarColor("rgb(38, 40, 51);");
        (async () => {
            try {
                setLoader(true);

                const res = await CrudService.getDeviceView(id);
                const channelNo = defaultChannelRef.current;

                deviceViewRef.current = res?.data ?? null;
                setDevice(res?.data);
                let icons = res?.data?.attributes?.EntityAddressItem?.Icon
                setTitleIcon(icons?.class_name)
                setSelectedIcon(icons)
                setDeviceName(res?.data?.attributes?.name)

                setProvidersState(
                    res?.data?.entityAddressItemProviders.map((provider) => ({
                        association_id: provider?.association_id,
                        on_off:
                            (provider?.provider_devices?.length
                                ? provider?.provider_devices[0].on_off
                                : provider?.on_off) || false,
                    }))
                );
                if (res?.data?.reportTypes) {
                    let obj = {};
                    for (let report of res?.data?.reportTypes) {
                        obj[report.report_type_identifier] = report.report_type_name;
                    }
                    setReportType(obj);
                }
                const deviceParameter = await CrudService.getDeviceParameter();
                setParameter(() => [...deviceParameter.data])
                setName({ text: res.data.attributes?.name });
                setNotified(res.data.attributes?.is_notified);
                setShare(res.data.attributes?.PublicShareDevice?.is_public ?? false);
                const selected_phone = res.data.attributes?.SelectedPhone;
                setPhoneEnv({
                    is_production: selected_phone?.is_production,
                    is_sandbox: selected_phone?.is_sandbox,
                    is_development: selected_phone?.is_development,
                });
                setSelectedMode(res.data.attributes.DeviceMode)
                setMapIdentifier(res.data.attributes?.EntityAddressItem?.map_identifier ?? '')
                setIdentifierValue(res.data.attributes.DeviceIdentifierValues.filter((e) => e.identifier_type_id == 1)[0]?.value ?? null)
                setParamValues(res?.data?.monitorParameterValues);

                const deviceValue = res?.data?.latestWebhookData?.device_value ?? null;
                latestDeviceValueRef.current = deviceValue;
                appliedChannelRef.current = channelNo;
                const lastRecord = applyChannelScope(res?.data, channelNo, deviceValue);

                if (res?.data?.latestWebhookData) {
                    let linked_devices = res?.data?.latestWebhookData.children.length > 0 ? res?.data?.latestWebhookData.children : res?.data?.latestWebhookData.parents
                    setLinkedDeviceData(linked_devices)
                    setDeviceStatusName(res?.data?.latestWebhookData?.StatusType?.status_name); // TODO: changes
                    setDeviceUpdated(lastRecord?.last_updated ?? lastRecord?.timestamp);
                    setAnalysisData(res?.data?.latestWebhookData?.analysis_data ?? null)
                } else {
                    setLoader(false);
                    setNotifyAlert(`There is no logs data available for this device`)
                    return
                }

                setLoader(false);

                await refreshChannelAlerts(channelNo);

                checkActiveServiceRequest();
                if (selectedTab === 4) {
                    serviceRequestList(res?.data?.attributes?.EntityAddressItem?.address_item_id)
                }

                const device_job = await CrudService.getActiveJobForTruck(res?.data?.attributes.address_item_id);
                if (device_job.success) {
                    setJobStateData({
                        data: device_job?.data,
                        from_state: device_job?.data.current_state,
                        to_state: device_job?.transitions.to_state,
                        reason: device_job?.transitions.trigger_reason,
                        timestamp: device_job?.transitions.transition_timestamp,
                        duration: device_job?.data?.duration_seconds
                    })
                }
            } catch (err) {
                if (err.status == 400) {
                    navigate("/user-profile");
                }
                console.error(err);
            }
        })();

        return () => resetAllState();
        // defaultChannel intentionally omitted: channel switches are handled by the effect below.
    }, [id, dataTableUpdate, serviceStatusUpdate, wsEmit]);

    // Channel switch: recompute channel-scoped state from loaded data, refetch only that channel's alerts.
    useEffect(() => {
        if (!deviceViewRef.current) return; // initial fetch applies the channel itself
        if (String(appliedChannelRef.current) === String(defaultChannel)) return;
        appliedChannelRef.current = defaultChannel;
        setActiveAlerts([]);
        applyChannelScope(deviceViewRef.current, defaultChannel, latestDeviceValueRef.current);
        refreshChannelAlerts(defaultChannel);
    }, [defaultChannel]);

    useEffect(() => {
        if (selectedTab == 1) {
            allAlerts(page, rowsPerPage)
        }
        if (selectedTab === 3) {
            alertRulesList()
        }
        if (selectedTab === 4) {
            serviceRequestList()
        }
    }, [id, selectedTab, page, rowsPerPage, reportType, defaultChannel])

    function resetAllState() {
        deviceViewRef.current = null;
        latestDeviceValueRef.current = null;
        appliedChannelRef.current = null;
        setName({ text: "", error: false, textError: "" });
        setParamValues([]);
        setPercent(0);
        setParamValue(undefined);
        setDevice(undefined);
        setTableData([]);
        setServiceStatusUpdate("");
        setServiceRequestId("");
        setLogServiceRequestId("");
        setDeviceStatusName("");
        setCalibrateDeviceModal(false);
        setDeviceDisconnectModal(false);
        setExpandedIndexArray([true, true, true, ...Array(6).fill(false)]);
        setNotified(false);
        setShare(false);
        setSelectedTab(parseInt(serviceRequestSelectedTab) || 0);
        setOpenViewModal(false);
        setServiceRequestLogModal(false);
        setAlert(undefined);
        setAlertTableData([]);
        setAlertRule([]);
        setAlertRules([]);
        setEventTableData([]);
        setServiceRequests([]);
        setServiceRequest([]);
        setAlertRuleTableData([]);
        setServiceRequestTableData([]);
        setServiceModal(false);
        setServiceRequestEditFlag(false);
        setSelectedRows({});
        setCheckSelectedRowsFlag(false);
        setSelectedRowsIdArray([]);
        setMultiStatusEditModal(false);
        setDataTableUpdate("");
        setSelectedRequestType("");
        setServiceRequestDeleteFlag(false);
        setNotification({ value: false, text: "" });
        setPillbarColor("rgb(38, 40, 51);");
        setProvidersState([]);
        setActiveAlerts([]);
        setActiveServiceRequest(null);
        setOpenModal(false);
        setPhoneEnvModal(false);
        setLoader(false);
        setPhoneEnv({ is_production: false, is_sandbox: false, is_development: true });
        setGps({ latitude: "", longitude: "", edit: false });
        setDeviceUpdated("");
        setTabsOrientation("horizontal");
        setReportType({});
        setEmit(1);
        setOpenMonitorEditModal(false);
        setSelectedThresholds([]);
        setOpenContactDetailsEditModal(false);
        setOpenDeviceInfoEditModal(false);
        setOpenDeviceSetupEditModal(false);
        setOpenDeviceSettingModal(false);
        setDeviceSetupFields(deepCopy(deviceFields));
        setOriginalDeviceSetupFields(deepCopy(deviceFields));
        setNavbarTitle("");
        setTitleIcon(null);
        setSelectedIcon(null);
        setDeviceName(null);
        setJsonTree(false);
        setRawDataValue({});
        setRequiredThresholds([]);
        setIsAttributeRequired(false);
        setIconList([]);
        setModeList([]);
        setSelectedMode(null);
        setMapIdentifier(null);
        setParameter([]);
        setIdentifierValue(null);
        setSelectedLogInfo(null);
        setNotifyAlert(null);
    }

    const formatTemp = (temp) => {
        if (temp === null || temp === undefined) return 'N/A';
        return `${temp.toFixed(1)}°F`;
    };

    const getTempColor = (temp) => {
        if (!temp || typeof temp !== 'number') return 'gray';
        if (temp < 0) return 'blue';      // Cold
        if (temp < 15) return 'cyan';     // Cool
        if (temp < 25) return 'green';    // Comfortable
        if (temp < 35) return 'orange';   // Warm
        return 'red';                     // Hot
    };

    async function checkActiveServiceRequest() {
        try {
            const serviceAlertsRes = await CrudService.getActiveServiceRequest(id);
            setActiveServiceRequest(serviceAlertsRes?.data);
        } catch (err) {
            console.error('checkActiveServiceRequest', err)
        }
    }

    async function allAlerts(page, rowsPerPage) {
        try {
            let resp = await CrudService.getDeviceAlerts(id, page, rowsPerPage, defaultChannel);
            let alertFilter = getAlertRows(resp.data, percent);
            setAlertTableData(alertFilter);
            countRef.current = resp?.pagination?.total ?? resp?.count
        } catch (error) {
            console.error('allAlerts', error)
        }
    }

    async function alertRulesList() {
        try {
            const resp = await CrudService.getAlertRules({ id });
            if (resp.data) {
                setAlertRules(resp.data);
                // let rules = getAlertRuleRows(resp.data)
                // setAlertRuleTableData(rules);
            }
        } catch (error) {
            console.error('alertRules', error)
        }
    }

    function updateNewRules(data) {
        let rules = getAlertRuleRows(data)
        setAlertRuleTableData(rules);
    }

    async function serviceRequestList(address_id = null) {
        // TODO: issue here addrss item id
        let address_item_id = address_id ?? device?.attributes?.EntityAddressItem?.address_item_id;
        if (address_item_id) {
            const resp = await CrudService.getServiceRequests(address_item_id);
            if (resp.data) {
                setServiceRequests(resp.data);
                let requests = getServiceRequestRows(resp.data)
                setServiceRequestTableData(requests);
            }
        }
    }

    async function updateDevice(data) {
        latestDeviceValueRef.current = data;
        const ch = defaultChannelRef.current;
        let latestRecord = { data: data?.channels?.[ch], ...data, device_setup: paramValue?.device_setup }
        setParamValue(latestRecord);
        setDeviceUpdated(latestRecord?.last_updated ?? latestRecord?.timestamp);
        setPercent(data?.channels?.[ch]?.fill_percentage ?? data?.channels?.[ch]?.current_value ?? 0);
        if (data?.linked_devices) {
            setLinkedDeviceData(data?.linked_devices)
        }
    }

    async function updateAlert(data, type) {
        if (type == 'Heal') {
            const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id, defaultChannel);
            let alertData = deviceAlertsRes?.data?.alerts?.reverse()
            setActiveAlerts(alertData ?? []);
            if (alertData?.length > 0) {
                setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex)
            } else {
                setPillbarColor("rgb(38, 40, 51);")
            }
        } else {
            setActiveAlerts([data]);
            setPillbarColor(data?.AlertType?.BadgeDetail?.font_color_hex)
        }
    }

    useEffect(() => {
        if (alertRules?.length) {
            let rules = getAlertRuleRows(alertRules)
            setAlertRuleTableData(rules);
        } else {
            setAlertRuleTableData([])
        }
    }, [alertRules])

    useEffect(() => {
        checkRowSelected();
    }, [selectedRows]);

    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: "",
                });
            }, 5000);
        }
    }, [notification]);

    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 100) {
                setNavbarTitle(device?.attributes?.name || ""); // Set device name when scrolled down
            } else {
                setNavbarTitle(""); // Remove when scrolled up
            }
        }

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [device?.attributes?.name]);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    const handlePhoneSwitch = (value, attr) => {
        setPhoneEnv((e) => ({ ...e, [attr]: value }));
    };

    const clickSetPhoneOption = async () => {
        const res = await CrudService.setPhoneOption({
            device_id: device.id,
            option: phoneEnv,
        });
        if (res.success) {
            device.attributes.SelectedPhone = {
                ...device.attributes.SelectedPhone,
                ...phoneEnv,
            };
        }

        setNotification({
            value: true,
            text: res.msg,
            bgColor: "info",
        });
        setPhoneEnvModal(false);
    };

    const clickCancelSelection = (e) => {
        setSelectedRows([]);
    };
    const checkRowSelected = () => {
        let result = false;
        let _selectedRowIdArray = [];

        for (const key in selectedRows) {
            if (selectedRows?.[key] == true) {
                result = true;
                _selectedRowIdArray.push(key);
            }
        }
        setSelectedRowsIdArray(_selectedRowIdArray);
        setCheckSelectedRowsFlag(result);
    };

    const showToast = (result) => {
        setNotification({
            value: true,
            text: result.message,
            bgColor: result.status == "201" ? "info" : "error",
        });
    };

    const handleCloseMultiStatusEditModal = () => {
        setMultiStatusEditModal(false);
    };

    const handleOpenMonitorEditModal = () => {
        const newDeviceThresholds = selectedChannelThresholds?.map((threshold) => ({
            ...threshold,
            label: threshold?.DeviceParameter?.parameter_name,
            parameter_name: threshold?.DeviceParameter?.parameter_name,
            is_threshold_required: threshold?.DeviceParameter?.is_threshold_required,
            field_type_id: threshold?.DeviceParameter?.field_type_id,
            MessageTemplate: { attributes: threshold?.MessageTemplate },
        }));
        setSelectedThresholds(newDeviceThresholds);
        setOpenMonitorEditModal(true);
    };

    const handleCloseMonitorEditModal = () => {
        setOpenMonitorEditModal(false);
    };

    const handleOpenContactsDetailsEditModal = () => {
        setOpenContactDetailsEditModal(true);
    };

    const handleCloseContactDetailsEditModal = () => {
        setOpenContactDetailsEditModal(false);
    };

    const handleOpenDeviceSetupEditModal = () => {
        setOriginalDeviceSetupFields(deviceSetupFields);
        setOpenDeviceSetupEditModal(true);
    };

    const handleCloseDeviceSetupEditModal = () => {
        setDeviceSetupFields(originalDeviceSetupFields);
        setOpenDeviceSetupEditModal(false);
    };

    const handleOpenDeviceInfoEditModal = async () => {
        const resIconsList = await CrudService.getIcons();
        if (resIconsList) {
            setIconList(resIconsList.data)
        }
        const resModeList = await CrudService.getDeviceModes();
        if (resModeList) {
            setModeList(resModeList.data)
        }
        setOriginalDeviceSetupFields(deviceSetupFields);
        setOpenDeviceInfoEditModal(true);
    };

    const handleCloseDeviceInfoEditModal = () => {
        setDeviceSetupFields(originalDeviceSetupFields);
        setOpenDeviceInfoEditModal(false);
    };

    const handleLocationChange = (newLocation) => {
        const payload = {
            deviceId: device.id,
            addressItemId: renderText('entity_address_item'),
            attributes: {
                ...deviceSetupFields,
                latitude: newLocation.lat,
                longitude: newLocation.lng,
            },
        };

        setDeviceSetupFields({
            ...deviceSetupFields,
            latitude: newLocation.lat,
            longitude: newLocation.lng,
        });

        handleSubmitDeviceInfoEdit(payload);
    };

    const handleSubmitContactDetailsEdit = async (e) => {
        e.preventDefault();
        let payload = {
            address_item_id: device?.attributes?.EntityAddressItem?.address_item_id,
            payload: selectedContactDeviceAccess.current
        }

        try {

            let resp = await CrudService.updateContactDeviceAccess(payload)

            if (resp.success) {
                toast.success(resp.msg)
                setDevice((prevDevice) => ({
                    ...prevDevice,
                    contacts: resp.data,
                }));
                setOpenContactDetailsEditModal(false)
            } else {
                toast.info(resp.msg ?? 'Issue occured')
            }

        } catch (error) {
            console.error('handleSubmitContactDetailsEdit', error)
            toast.error(error.error)
        }
    };

    const handleSubmitMonitorEdit = async (e) => {
        e.preventDefault();
        let hasValidationError = false;
        const updatedSelectedThresholds = [...selectedThresholds];
        let list_of_required;
        let thresholdMapped = updatedSelectedThresholds.map((e) => e.id)
        let hasRequiredError = requiredThresholds.every((e) => {
            if (thresholdMapped.includes(e.id)) {
                return true
            }
            list_of_required = e
            return false
        })
        if (!hasRequiredError) {
            toast.info(`Parameter ${list_of_required.DeviceParameter.parameter_name} is required!`)
            return
        }
        updatedSelectedThresholds.forEach((updatedSelectedThreshold) => {
            updatedSelectedThreshold.channel_number = Number(defaultChannel)
            const validError = validateInput(
                updatedSelectedThreshold?.field_type_id,
                updatedSelectedThreshold?.threshold_value
            );
            updatedSelectedThreshold.validationError = validError;
            if (validError) {
                hasValidationError = validError;
                return;
            }
        });

        if (hasValidationError) return;

        try {
            const payload = {
                deviceId: device.id,
                deviceParameterThresholds: updatedSelectedThresholds,
                channel_number: Number(defaultChannel)
            };
            const response = await CrudService.updateDeviceThreshold(payload);
            const saved = Array.isArray(response?.data) ? response.data : [];
            const channelKey = String(defaultChannel);
            // If the API returns every channel's thresholds use it as-is, otherwise merge this channel in.
            const savedIsFullList = saved.some((t) => String(t.channel_number) !== channelKey);
            const merged = savedIsFullList
                ? saved
                : [
                    ...(device?.deviceThresholds ?? []).filter((t) => String(t.channel_number) !== channelKey),
                    ...saved,
                ];
            setDevice((prev) => ({ ...prev, deviceThresholds: merged }));
            if (deviceViewRef.current) {
                deviceViewRef.current = { ...deviceViewRef.current, deviceThresholds: merged };
            }
            setSelectedThresholds(updatedSelectedThresholds);
            setSelectedChannelThresholds(saved.filter((t) => String(t.channel_number) === channelKey))
            setOpenMonitorEditModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSubmitDeviceSetupEdit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                deviceId: device.id,
                addressItemId: renderText('entity_address_item'),
                attributes: { ...deviceSetupFields, deviceName },
            };
            await CrudService.updateDeviceAttributes(payload);
            setOpenDeviceSetupEditModal(false);
            setOpenDeviceInfoEditModal(false);
            setName({ text: deviceName })
            setNavbarTitle(deviceName)
            setDevice((prev) => ({ ...prev, attributes: { ...prev.attributes, name: deviceName } }))
            let isAttributeRequired = Object.entries(deviceSetupFields).filter((e) => !['latitude', 'longitude'].includes(e[0])).some((e) => e[1] == '')
            setIsAttributeRequired(isAttributeRequired)
        } catch (err) {
            console.error(err);
            toast.error(err.message)
        }
    };

    const handleSubmitDeviceInformationEdit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                device_id: device.id,
                address_item_id: device.attributes.address_item_id,
                channel_address_item_id: channelEntity?.address_item_id ?? device.attributes.address_item_id,
                device_name: deviceName,
                latitude: deviceSetupFields.latitude ?? '',
                longitude: deviceSetupFields.longitude ?? '',
                map_identifier: mapIdentifier,
                mode: selectedMode,
                icon: selectedIcon
            }

            let resp = await CrudService.updateDeviceInformation(payload)

            if (resp.success) {
                toast.info('Updated!')
            } else {
                toast.error(resp.msg)
            }

            setOpenDeviceInfoEditModal(false)
        } catch (err) {
            console.error('handleSubmitDeviceInformationEdit', err)
            toast.error(err.error)
        }
    }

    const handleSubmitDeviceInfoEdit = async (payload) => {
        try {
            await CrudService.updateDeviceAttributes(payload);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const getRows = (info) => {
        info.sort((a, b) => b.id - a.id);
        let updatedInfo = info.map((row, index) => {
            let previousIndex;
            const channel = row.data?.channels?.[defaultChannel]
            if (!channel) {
                return null
            }
            if (info.length - 1 == index) {
                previousIndex = index;
            } else {
                previousIndex = index + 1;
            }
            let obj_flag = isPressure ? 'actual_fluid_height' : 'fill_percentage'
            const previous_percent_level = info[previousIndex]?.data?.channels?.[defaultChannel]?.[obj_flag] ?? 0
            let check_drop = channel?.[obj_flag] - previous_percent_level;
            let percent_level_drop = check_drop < 1 ? Math.abs(check_drop).toFixed(0) : 0;
            let percent_level_increase = check_drop > 0 ? check_drop.toFixed(0) : 0;
            let state = ''
            if (channel?.state) {
                let con = <>
                    <i
                        className={channel?.state?.icon?.class_name}
                        style={{ marginRight: "8px" }}
                    ></i>
                    <span style={{ color: channel?.state?.display_color }} >{channel?.state?.display_label}</span>
                </>
                state = con
            }
            return {
                ...row,
                id: row?.id,
                actual_fluid_height: channel?.actual_fluid_height ?? 0,
                calibrated_level: channel?.calibrated_level ?? 0,
                raw_level: channel?.raw_level ?? 0,
                usable_height: channel?.usable_height ?? 0,
                fill_percentage: channel?.fill_percentage ?? 0,
                percent_level_drop: percent_level_drop,
                percent_level_increase: percent_level_increase,
                previous_percent_level: previous_percent_level,
                volume_level: formatNumber(channel?.volume_level ?? 0),
                date: row?.created_at,
                state
            };
        });
        return updatedInfo.filter(Boolean);
    };

    const dataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "State", accessor: "state", show: isStateAvail },
            {
                Header: isPressure ? 'Pressure (PSI)' : "Fluid Height",
                accessor: "actual_fluid_height",
                width: "10%",
                show: true,
            },
            {
                Header: isPressure ? "Calibrated Pressure" : 'Calibrated Value',
                accessor: "calibrated_level",
                width: "10%",
                show: true,
            },
            {
                Header: isPressure ? 'Raw Pressure Signal' : "Raw level",
                accessor: "raw_level",
                width: "10%",
                show: true,
            },
            {
                Header: "Usable Height",
                accessor: "usable_height",
                width: "10%",
                show: !isPressure
            },
            {
                Header: "Percent Level",
                accessor: "fill_percentage",
                width: "15%",
                show: true,
                show: !isPressure
            },
            {
                Header: isPressure ? "Percent Drop" : "Percent Level Drop",
                accessor: "percent_level_drop",
                width: "15%",
            },
            {
                Header: isPressure ? "Percent Increase" : "Percent Level Increase",
                accessor: "percent_level_increase",
                width: "15%",
                show: true,
            },
            {
                Header: isPressure ? "Previous Level" : "Previous Percent Level",
                accessor: "previous_percent_level",
                width: "15%",
                show: true,
            },
            {
                Header: "Volume Level",
                accessor: "volume_level",
                width: "15%",
                show: !isPressure
            },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "",
                show: true,
                isSorted: false,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                padding: '5px'
                            }}
                        >
                            <IconButton onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>
                                <Visibility />
                            </IconButton>
                            {/* <MDButton variant="outlined" color="info" onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>View</MDButton> */}
                        </div>
                    );
                },
            },
        ],
        rows: tableData, // Assuming tableData is your original data array
    };
    const clickAlertRuleEditHandler = async (ruleId) => {
        let res = await CrudService.getAlertRule(ruleId);
        setAlertRule(res);
        setOpenViewModal(true);
    };

    const clickAlertRuleDeleteHandler = async (e, ruleId) => {
        try {
            if (!confirm("Are you sure you want to delete this alert rule?")) {
                e.nativeEvent.stopImmediatePropagation();
            } else {
                await CrudService.deleteAlertRule(ruleId);
                // the delete does not send a response
                // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
                alertRulesList()
                setNotification({
                    value: true,
                    text: "The alert rule has been successfully deleted",
                });
            }
        } catch (err) {
            // it sends error is the item is associated with an item
            console.error(err);
            if (err.hasOwnProperty("errors")) {
                setNotification({
                    value: true,
                    text: err.errors[0].detail,
                });
            }
            return null;
        }
    };

    const clickServiceRequestEditHandler = async (e, service_request_id) => {
        e.stopPropagation();
        setServiceRequestEditFlag(true);
        let res = await CrudService.getServiceRequest(service_request_id);

        setServiceRequest(res.data.attributes);
        setServiceModal(true);
    };

    const clickServiceRequestLogHandler = async (e, service_request_id) => {
        e.stopPropagation();
        setServiceRequestLogModal(true);
        setLogServiceRequestId(service_request_id);
    };

    const clickServiceRequestViewHandler = (e, service_request_id) => {
        e.stopPropagation();
        navigate(`/service-request-detail/${service_request_id}`);
    };
    const clickServiceRequestDeleteHandler = async (e, service_request_id) => {
        e.stopPropagation();
        setServiceRequestDeleteFlag(true);
        try {
            if (!confirm("Are you sure you want to delete this service request?")) {
                e.nativeEvent.stopImmediatePropagation();
            } else {
                await CrudService.deleteServiceRequest(service_request_id);
                // the delete does not send a response
                // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
                serviceRequestList();
                checkActiveServiceRequest();
                setNotification({
                    value: true,
                    text: "The service request has been successfully deleted",
                });
            }
        } catch (err) {
            // it sends error is the item is associated with an item
            console.error(err);
            if (err.hasOwnProperty("errors")) {
                setNotification({
                    value: true,
                    text: err.errors[0].detail,
                });
            }
            return null;
        }
    };

    const getAlertRuleRows = (info) => {
        let updatedInfo = info.map((row) => {
            let frequency = "";
            if (row.attributes?.frequency && row.attributes?.frequency != null) {
                frequency =
                    row.attributes?.frequency +
                    " min" +
                    (row.attributes?.frequency > 1 ? "(s)" : "");
            }

            let rule_type =
                row.attributes?.module_id === 12
                    ? "Alert"
                    : row.attributes?.module_id === 13
                        ? "Service Request"
                        : row.attributes?.module_id === 22
                            ? "Job State Alert"
                            : "";

            const event_type_id = row.attributes?.event_type_id;
            let message_template_name = "";
            if (event_type_id == 14) {
                message_template_name = row.attributes?.SendgridTemplate?.name;
            }
            if (event_type_id == 15) {
                message_template_name = row.attributes?.MessageTemplate?.name;
            }
            if (event_type_id == 36) {
                message_template_name = row.attributes?.MessageTemplate?.name;
            }
            let { AlertType, AlertSubType, Contact, ContactAddress, EventType, SendToType, StatusOption } = row.attributes
            let address = `${Contact?.first_name} ${Contact?.last_name} - ${ContactAddress?.contact_address}`
            return {
                id: row?.id,
                rule_type: rule_type,
                alert_type: AlertType?.type_name,
                alert_type_category: AlertType?.category,
                alert_sub_type: AlertSubType?.sub_type_name,
                event_type: EventType?.name,
                message_template_name: message_template_name,
                address: address,
                send_to_type: SendToType?.send_to_type_name,
                frequency: frequency,
                state_from: row?.attributes?.state_from || '',
                state_to: row?.attributes?.state_to || '',
                status_text:
                    StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={StatusOption?.BadgeDetail?.variant}
                        badgeContent={StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });

        return updatedInfo;
    };

    const alertRuledataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "Status Badge", accessor: "status", show: true },
            { Header: "Status ", accessor: "status_text", show: false },

            { Header: "Rule Type", accessor: "rule_type", show: true },
            { Header: "Alert Type", accessor: "alert_type", show: true },
            {
                Header: "Alert Type Category",
                accessor: "alert_type_category",
                show: true,
            },
            { Header: "Alert Sub Type", accessor: "alert_sub_type", show: true },
            { Header: "Event Type", accessor: "event_type", show: true },
            {
                Header: "Message Template Name",
                accessor: "message_template_name",
                show: true,
            },
            { Header: "Address", accessor: "address", show: true },
            { Header: "Send Type", accessor: "send_to_type", show: true },
            { Header: "Frequency", accessor: "frequency", show: true },
            { Header: "State From", accessor: "state_from", show: true },
            { Header: "State To", accessor: "state_to", show: true },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="Edit Alert Rule">
                                <IconButton
                                    onClick={() =>
                                        clickAlertRuleEditHandler(info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <EditIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Alert Rule">
                                <IconButton
                                    onClick={(e) =>
                                        clickAlertRuleDeleteHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <DeleteIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    );
                },
            },
        ],
        rows: alertRuleTableData, // Assuming tableData is your original data array
    };

    const getEventRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row?.event_id,
                alert_type: row?.AlertType?.type_name,
                parameter_name: row?.DeviceParameter?.parameter_name,
                percent_value: row?.percent_change,
                prev_value: row?.previous_value,
                current_value: row?.new_value,
                volume: row?.volume_change,
                date: row?.event_timestamp,
                raw_data: row?.WebhookRawDatum ? row?.WebhookRawDatum?.value : {}
            };
        });

        return updatedInfo;
    };

    const getJobsRows = (info) => {
        // let updatedInfo = info.map((row) => {
        //     return {
        //         id: row?.id,
        //         alert_type: row?.AlertType?.type_name,
        //         parameter_name: row?.DeviceParameter?.parameter_name,
        //         percent_value: row?.percent_change,
        //         prev_value: row?.previous_value,
        //         current_value: row?.new_value,
        //         volume: row?.volume_change,
        //         date: row?.event_timestamp,
        //         raw_data: row?.WebhookRawDatum ? row?.WebhookRawDatum?.value : {}
        //     };
        // });

        return info;
    };

    const openJsonTreedata = (e, value) => {
        e.stopPropagation();
        setRawDataValue(value)
        setJsonTree(true)
    }

    const eventdataTableData = {
        columns: [
            {
                Header: "ID",
                accessor: "id",
                show: true,
                Cell: (info) => {
                    return <a onClick={(e) => openJsonTreedata(e, info.cell.row.original.raw_data)}>{info.value}</a>
                }
            },
            { Header: "Type", accessor: "alert_type", show: true },
            { Header: "Parameter Name", accessor: "parameter_name", show: true },
            { Header: "Current Value", accessor: "current_value", show: true },
            { Header: "Previous Value", accessor: "prev_value", show: true },
            {
                Header: "Percent Change",
                accessor: "percent_value",
                show: true,
                Cell: (info) => `${Number(info.value).toFixed(0)}%`,
            },
            {
                Header: "Volume Change ( Gallons )",
                accessor: "volume",
                show: true,
                Cell: (info) => `${Number(info.value).toFixed(0)}`,
            },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
        ],
        rows: eventTableData, // Assuming tableData is your original data array
    };
    const JobTableColumns = [
            {
                Header: "ID",
                accessor: "id",
                show: true,
                Cell: (info) => {
                    return <a href={`/job-view/${info.value}`} target="_blank" rel="noopener noreferrer">{info.value}</a>
                }
            },
            { Header: "Name", accessor: "job_session_name", show: true },
            { Header: "Current State", accessor: "current_state", show: true },
            { Header: "Volume Collected", accessor: "volume_collected_gallons", show: true },
            { Header: "Volume Discharged", accessor: "volume_discharged_gallons", show: true },
            {
                Header: "Residual Volume",
                accessor: "residual_volume_gallons",
                show: true,
                // Cell: (info) => `${Number(info.value).toFixed(0)}%`,
            },
            {
                Header: "Total Duration",
                accessor: "total_duration_seconds",
                show: true,
                Cell: (info) => {
                    const totalSeconds = Number(info.value);
                    const totalMinutes = Math.floor(totalSeconds / 60);
                    const hours = Math.floor(totalMinutes / 60);
                    const minutes = totalMinutes % 60;
                    return `${hours}h ${minutes}m`;
                },
            },
            {
                Header: "started_at",
                accessor: "started_at",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {isValid(info.value) && moment(info.value).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "completed_at",
                accessor: "completed_at",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {isValid(info.value) && moment(info.value).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "state_changed_at",
                accessor: "state_changed_at",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {isValid(info.value) && moment(info.value).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
        ]

    const getServiceRequestRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row.attributes?.service_request_id,
                user: row.attributes?.user?.name,
                entityAddressItem: row.attributes?.EntityAddressItem?.name,
                provider: row.attributes?.Provider?.provider_name,
                serviceItem: row.attributes?.ServiceItem?.item_name,
                request_date: row.attributes?.request_date,
                status: row.attributes?.StatusOption,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
            };
        });

        return updatedInfo;
    };

    const serviceRequestdataTableData = {
        columns: [
            { Header: "ID", accessor: "id", width: "12rem", show: true },
            {
                Header: "Status Badge",
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <StyledBadge
                            color={
                                info.cell.row.original?.status?.BadgeDetail?.color || "primary"
                            }
                            variant={
                                info.cell.row.original?.status?.BadgeDetail?.variant ||
                                "contained"
                            }
                            badgeContent={
                                info.cell.row.original.status?.StatusType?.status_name
                            }
                            style={{ marginLeft: "30px" }}
                        ></StyledBadge>
                    );
                },
            },
            { Header: "Status", accessor: "status_text", width: "12rem", show: true },

            {
                Header: "Entity Address Item",
                accessor: "entityAddressItem",
                width: "12rem",
                show: true,
            },
            { Header: "Provider", accessor: "provider", width: "12rem", show: true },
            {
                Header: "Service Item",
                accessor: "serviceItem",
                width: "12rem",
                show: true,
            },
            {
                Header: "Requested Date",
                accessor: "request_date",
                width: "12rem",
                show: true,
            },
            { Header: "User", accessor: "user", width: "12rem", show: true },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="View Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestViewHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <SubjectIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Show Status Change Log">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestLogHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <ServiceRequestLogIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestEditHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <EditIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestDeleteHandler(
                                            e,
                                            info.cell.row.original.id
                                        )
                                    }
                                >
                                    <MDTypography>
                                        <DeleteIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    );
                },
            },
        ],
        rows: serviceRequestTableData, // Assuming tableData is your original data array
    };

    const getAlertRows = (info, percent) => {
        let updatedInfo = info.map((row) => {
            const createdAt = row.attributes.created_at
                ? moment(row.attributes.created_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const updatedAt = row.attributes.updated_at
                ? moment(row.attributes.updated_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const subType = row.attributes.is_parent
                ? "Alert Created"
                : row.attributes.is_healed
                    ? "Alert Healed"
                    : "Alert Resent";

            return {
                id: row.id,
                device_id: row.attributes?.device_id,
                alert_type_id: row.attributes?.alert_type_id,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                device: row.attributes.Device?.name,
                parameter_name: row.attributes?.DeviceParameter?.label ?? '',
                sub_type: subType,
                is_parent: row.attributes?.is_parent,
                threshold_value: row.attributes.threshold,
                exceed_value: row.attributes.exceed_value,
                // TODO: fix current value
                current_value: !['', null, 'null', undefined, NaN].includes(row.current_value) ? row.current_value : percent,
                created_at: createdAt,
                updated_at: updatedAt,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });
        return updatedInfo;
    };

    const clickStatusEdit = (e) => {
        setMultiStatusEditModal(true);
    };

    const alertColumns = [
        { Header: "ID", accessor: "id", width: "5%", show: true },
        { Header: "Status Badge", accessor: "status", width: "5%", show: true },
        { Header: "Status", accessor: "status_text", show: false },
        { Header: "Alert Type", accessor: "alert_type", width: "10%", show: true },
        { Header: 'Parameter', accessor: 'parameter_name', width: '10%', show: true },
        { Header: 'Threshold Value', accessor: 'threshold_value', width: '5%' },
        { Header: 'Exceed Value', accessor: 'exceed_value', width: '5%' },
        { Header: 'Current Value', accessor: 'current_value', width: '5%' },
        {
            Header: "Alert Category",
            accessor: "alert_type_category",
            width: "10%",
            show: true,
        },
        { Header: "Sub Type", accessor: "sub_type", width: "8%", show: true },
        { Header: "Created At", accessor: "created_at", width: "15%", show: true },
        { Header: "Updated At", accessor: "updated_at", width: "15%", show: true },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
        },
    ];

    const clickViewHandler = async (id, value) => {
        let data = await CrudService.getAlert(id);
        setAlert(data);
        setOpenViewModal(true);
    };

    const clickDeleteHandler = async (e, del_id) => {
        try {
            if (!confirm('Are you sure you want to delete this alert?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                await CrudService.deleteAlert(del_id)
                allAlerts(page, rowsPerPage)
                setNotification({
                    value: true,
                    text: 'The Alert has been successfully deleted',
                })
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('errors')) {
                setNotification({
                    value: true,
                    text: err.errors[0].detail,
                })
            }
            return null
        }
    }

    const handlePublicDeviceShare = async (e) => {
        try {
            if (!confirm('Are you sure you want to update this device share?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                let response = await CrudService.publicShareDevice({
                    device_id: id,
                    status: !isShare
                })
                setNotification({
                    value: true,
                    text: 'The Status has been successfully updated',
                })
                setShare(!isShare)
                if (response?.data) {
                    device.attributes.PublicShareDevice = response.data
                }
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('errors')) {
                setNotification({
                    value: true,
                    text: err.errors,
                })
            }
            return null
        }
    }

    const clickServiceReqeustRowHandler = (service_request_id) => {
        setServiceRequestId(service_request_id);
    };

    const StyledLinearProgress = StyledProgress(pillbarColor)

    const handleExpand = (index) => {
        setExpandedIndexArray((prevArray) =>
            prevArray.map((item, idx) => (idx === index ? !item : item))
        );
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        localStorage.setItem("serviceRequestTab", newValue);
    };

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.info("Copied!")
            })
            .catch((error) => {
                console.error("Failed to copy text:", error);
            });
    }

    const cardStyle = (index) => ({
        display: "flex",
        flexDirection: "column",
        ...(expandedIndexArray[index] && { minHeight: "100%" }),
    });

    const styles = devStyle(isTabletOrMobile)

    const handleViewClose = () => {
        setOpenViewModal(false);
    };
    const handleServiceRequestModalClose = () => {
        setServiceRequestLogModal(false);
    };

    const handleCalibrateDeviceModalClose = () => {
        setCalibrateDeviceModal(false);
    };
    const handleDeviceDisconnectModalClose = () => {
        setDeviceDisconnectModal(false);
    };

    const handleServiceModalClose = () => {
        setServiceModal(false);
    };

    // This function will handle the removal of the alert when clicked
    const handleClose = async (alertId, alertTypeId, deviceId) => {
        // Filter out the alert with the matching id
        const updatedAlerts = activeAlerts.filter(
            (alert) => alert.alert_id !== alertId
        );
        setActiveAlerts(updatedAlerts);
        const payload = {
            deviceId: deviceId,
            alertTypeId: alertTypeId,
        };
        await CrudService.updateNotificationStatus(payload);
    };

    const handleSelectedRows = (request_id, flag) => {
        if (
            serviceRequestEditFlag != true ||
            serviceRequestLogModal != true ||
            serviceRequestDeleteFlag != true
        ) {
            const firstSelectedServiceRequestId = getKeyWithSpecialValue(
                selectedRows,
                true
            );

            let serviceRequestType = "";
            if (firstSelectedServiceRequestId != undefined) {
                const selectedFirstRequest = serviceRequests.filter((request) => {
                    return (
                        request?.attributes?.service_request_id ==
                        firstSelectedServiceRequestId
                    );
                });
                if (selectedFirstRequest) {
                    const selectedRequestTypeTemp =
                        selectedFirstRequest[0]?.attributes.status_type_id;
                    serviceRequestType = selectedRequestTypeTemp;

                    setSelectedRequestType(selectedRequestTypeTemp);
                }
            } else {
                const firstRequest = serviceRequests.filter((request) => {
                    return request?.attributes?.service_request_id == request_id;
                });

                const firstRequestType = firstRequest[0]?.attributes?.status_type_id;
                serviceRequestType = firstRequestType;
            }

            const selectedServiceRequest = serviceRequests.filter((request) => {
                return request?.attributes?.service_request_id == request_id;
            });

            if (selectedServiceRequest) {
                if (
                    selectedServiceRequest[0]?.attributes?.status_type_id ==
                    serviceRequestType
                ) {
                    setSelectedRequestType(serviceRequestType);
                    setSelectedRows({
                        ...selectedRows,
                        [request_id]: flag,
                    });
                }
            }
        }
    };

    function checkAccess() {
        if (authContext.userDetail.role_id === 1) {
            return true
        }
        if (authContext.accessList.writeAccess.includes(Number(id))) {
            return true
        }

        // if(authContext.userDetail.role_id !== 6 && ability.can(type, 'devices')){
        //   return true
        // }

        return false
    }

    const handleProviderSwitchChange = async (association_id, newOnOffValue) => {
        setProvidersState((prevState) =>
            prevState.map((provider) =>
                provider.association_id === association_id
                    ? { ...provider, on_off: newOnOffValue }
                    : provider
            )
        );

        try {
            await CrudService.setProviderActive({
                association_id,
                on_off: newOnOffValue,
                device_id: device.id,
            });
            const serviceRequestssRes = await CrudService.getServiceRequests(
                device?.attributes?.EntityAddressItem.address_item_id
            );
            setServiceRequests(serviceRequestssRes.data);
        } catch (error) {
            console.error("Error updating provider:", error);
        }
    };

    const checkAllNotification = (alerts) => {
        let isAllNotification = false;
        alerts.forEach((alert) => {
            if (alert?.AlertType?.category != "notice") {
                isAllNotification = true;
                return;
            }
        });
        return isAllNotification;
    };

    const openModalFn = (type) => {
        if (type == "device") {
            setGps({
                latitude: paramValue?.latitude,
                longitude: paramValue?.longitude,
            });
        } else if (type == "item") {
            setGps({
                latitude: deviceSetupFields?.latitude,
                longitude: deviceSetupFields?.longitude,
                edit: true,
            });
        } else if (type == "itemButton") {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
                edit: true,
            });
        } else {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
            });
        }
        setOpenModal(true);
    };

    const clickExportLogsHandler = async () => {
        try {
            setDeviceLogModel(true)
        } catch (error) {
            console.error('clickExportLogsHandler error', error)
        }
    }

    const handleExport = async () => {
        try {
            const from_date = moment(dateRange[0][0]).format('YYYY-MM-DD');
            const to_date = moment(dateRange[1][0]).format('YYYY-MM-DD');

            if (pagin[0] < 1) {
                setNotification({
                    value: true,
                    text: 'Page should positive number',
                })
                return
            }

            if (pagin[1] < 1) {
                setNotification({
                    value: true,
                    text: 'No. of Pages should positive number',
                })
                return
            }

            const exportUrl = `${process.env.REACT_APP_API_URL}/devices/export/excel?device_id=${id}&from_date=${from_date}&to_date=${to_date}&page=${pagin[0]}&limit=${pagin[1]}`;
            window.open(exportUrl, '_blank');
            setDateRange([null, null])
            setDeviceLogModel(false)
        } catch (error) {
            console.error('clickExportLogsHandler error', error)
        }
    }

    const clickLogInfoHandler = (e, data) => {
        e.stopPropagation()
        if (data) {
            setSelectedLogInfo(data)
        } else {
            window.alert('No data')
        }
    }

    function renderText(type) {
        if (!type) return '';

        switch (type) {
            case 'item_type':
                return channelEntity ? channelEntity?.Item?.ItemType?.type_name : device?.attributes?.EntityAddressItem?.Item?.ItemType?.type_name || '';
            case 'item_type_name':
                return channelEntity ? channelEntity?.Item?.name : device?.attributes?.EntityAddressItem?.Item?.name || '';
            case 'entity_address_item':
                return channelEntity ? channelEntity?.address_item_id : device?.attributes?.EntityAddressItem?.address_item_id || '';
            case 'item_name':
                return channelEntity ? channelEntity?.name : device?.attributes?.EntityAddressItem?.name || '';
            case 'entity_address':
                return channelEntity ? channelEntity?.Item?.address : device?.attributes?.EntityAddressItem?.Item?.address || '';
            case 'address':
                const address = channelEntity ? channelEntity?.Address : device?.attributes?.EntityAddressItem?.Address;
                const addressModify = [address?.street_address1, address?.street_address2, [ address?.city, address?.state, address?.postal_code ].filter(Boolean).join(', ')].filter(Boolean).join(', ');
                return addressModify;
            default:
                return '';
        }
    }

    const DataRow = ({ label, value, styles, valueStyles = {} }) => (
        <TableRow>
            <TableCell style={styles.cell}>
                <MDTypography fontSize={1}>
                    <strong>{label}</strong>
                </MDTypography>
            </TableCell>

            <TableCell style={styles.cell}>
                <MDTypography fontSize={1} style={valueStyles} >{value ?? "-"}</MDTypography>
            </TableCell>
        </TableRow>
    )

    const ClickableRow = ({ label, value, onClick, styles }) => (
        <TableRow>
            <TableCell style={styles.cell}>
                <MDTypography fontSize={1}>
                    <strong>{label}</strong>
                </MDTypography>
            </TableCell>

            <TableCell
                style={{ ...styles.cell, cursor: "pointer" }}
                onClick={onClick}
            >
                <MDTypography fontSize={1}>
                    <a>{value}</a>
                </MDTypography>
            </TableCell>
        </TableRow>
    )

    const isValid = (val) => ![0, "0", null, undefined].includes(val);

    return (
        <DashboardLayout>
            <DashboardNavbar title={navbarTitle} titleIcon={titleIcon} />
            {notification.value && (
                <MDAlert
                    color={notification.bgColor}
                    my="20px"
                    sx={{
                        position: "sticky",
                        top: { md: "100px", xs: "50px" },
                        zIndex: "10000",
                    }}
                >
                    <MDTypography variant="body2" color="white">
                        {notification.text || ""}
                    </MDTypography>
                </MDAlert>
            )}

            <MDBox mt={0} mb={9}>
                <Grid justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={0} mb={0} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {titleIcon ? <i className={titleIcon} style={{ fontSize: "24px" }}></i> : ''} {device?.attributes?.name}{" "}
                                    {activeAlerts.length != 0 &&
                                        checkAllNotification(activeAlerts) ? (
                                        <i
                                            className={activeAlerts[0].AlertType?.Icon?.class_name ?? "fas fa-triangle-exclamation"}
                                            style={{ fontSize: "24px", color: `${activeAlerts[0]?.AlertType?.BadgeDetail?.font_color_hex ?? "#d32f2f"}` }}
                                        ></i>
                                    ) : (
                                        ""
                                    )}
                                </MDTypography>
                                {activeAlerts.map((alert) => (
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${alert?.AlertType?.BadgeDetail?.border_color_hex ?? "green"}`,
                                            alignItems: "center",
                                            backgroundColor: alert?.AlertType?.BadgeDetail?.background_color_hex ?? "#d1ffd6",
                                        }}
                                    >
                                        {/* Close button */}
                                        {alert?.AlertType?.category == "notice" && (
                                            <button
                                                style={{
                                                    position: "absolute",
                                                    top: "5px",
                                                    right: "5px",
                                                    background: "transparent",
                                                    border: "none",
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                }}
                                                onClick={() =>
                                                    handleClose(
                                                        alert?.alert_id,
                                                        alert?.alert_type_id,
                                                        alert?.device_id
                                                    )
                                                } // Replace with your close function
                                            >
                                                &times;
                                            </button>
                                        )}
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: alert?.AlertType?.BadgeDetail?.font_color_hex ?? "green",
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className={alert?.AlertType?.Icon?.class_name}
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color: alert?.AlertType?.BadgeDetail?.font_color_hex ?? "green",
                                                }}
                                            ></i>{" "}
                                            {alert?.AlertType?.type_name} -{" "}
                                            {alert?.AlertType?.description} &middot;{" "}
                                            {moment(alert?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                ))}
                                {linkedVehicles.length > 0 && (
                                    <Chip
                                        size="small"
                                        color="info"
                                        clickable
                                        icon={<i className="fa-solid fa-truck" style={{ fontSize: 12, marginLeft: 8 }} />}
                                        label={`${linkedVehicles.length} linked vehicle${linkedVehicles.length === 1 ? "" : "s"} · View location`}
                                        onClick={() =>
                                            showLinkedVehicleOnMap(selectedLinkedVehicleId ?? linkedVehicles[0].id)
                                        }
                                        sx={{ mt: 1, height: 24, borderRadius: "6px", fontWeight: 700 }}
                                    />
                                )}
                                <MDBox display="flex" justifyContent="center" mt={1} mb={1}>
                                    <MDButton
                                        type="button"
                                        size="small"
                                        color="info"
                                        variant={overviewEnabled ? "gradient" : "outlined"}
                                        aria-pressed={overviewEnabled}
                                        onClick={() => setViewMode((mode) => (mode === "classic" ? "overview" : "classic"))}
                                        sx={{ whiteSpace: "nowrap" }}
                                    >
                                        {overviewEnabled ? "Use classic view" : "Try new channel view"}
                                    </MDButton>
                                </MDBox>
                                {overviewEnabled ? (
                                    <MDBox textAlign="left">
                                        <ChannelOverview
                                            id="gateway-channels"
                                            channels={channelModels}
                                            selectedKey={selectedChannelModel?.key}
                                            onSelect={handleOverviewSelect}
                                            filter={channelFilter}
                                            onFilterChange={setChannelFilter}
                                        />
                                    </MDBox>
                                ) : (
                                    <Box
                                        sx={{
                                            width: '100%',
                                            overflowX: 'auto',
                                            '@media (max-width:600px)': {
                                                pb: 1.5,
                                            },
                                        }}
                                    >
                                        {channels.length ? (
                                            <Tabs
                                                value={String(defaultChannel)}
                                                onChange={(e, val) => {
                                                    e.stopPropagation();
                                                    setDefaultChannel(val);
                                                }}
                                                aria-label="channel tabs"
                                                indicatorColor="secondary"
                                                textColor="inherit"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                allowScrollButtonsMobile
                                                sx={{
                                                    minHeight: 48,
                                                    "& .MuiTabs-flexContainer": {
                                                        flexWrap: "nowrap"
                                                    },
                                                    "& .MuiTab-root": {
                                                        minWidth: { xs: 90, sm: 100, md: 120 }, // Responsive minWidth
                                                        paddingX: { xs: 0.5, sm: 2 }, // Reduce horizontal padding for mobile
                                                        fontSize: { xs: '0.78rem', sm: '0.92rem', md: '1rem' },
                                                    }
                                                }}
                                            >
                                                {channels.map((e, i) => (
                                                    <Tab
                                                        key={`channels_${e.channel_number}`}
                                                        label={
                                                            <span style={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                display: "inline-block",
                                                                maxWidth: 400, // prevent channel label overflowing on mobile
                                                                '@media (minWidth:600px)': {
                                                                    maxWidth: 90, // allow label to expand on desktop
                                                                }
                                                            }}>
                                                                {`${e.channel_name} (${e.channel_number})`}
                                                            </span>
                                                        }
                                                        value={String(e.channel_number)}
                                                        sx={{
                                                            maxWidth: { xs: 120, sm: 200 },
                                                            minHeight: { xs: 36, sm: 48 },
                                                        }}
                                                    />
                                                ))}
                                            </Tabs>
                                        ) : (
                                            <MDTypography variant="body2" color="text">
                                                No channels are configured for this gateway.
                                            </MDTypography>
                                        )}
                                    </Box>
                                )}


                                {
                                    isAttributeRequired ?
                                        <div
                                            style={{
                                                display: "flex",
                                                position: "relative",
                                                padding: "5px",
                                                marginBottom: "10px",
                                                border: `1px solid green`,
                                                alignItems: "center",
                                                backgroundColor: "#d1ffd6",
                                            }}
                                        >
                                            <MDTypography
                                                variant="h6"
                                                style={{
                                                    fontSize: "12px",
                                                    color: "green",
                                                    marginLeft: "10px",
                                                }}
                                            >
                                                Device Setup Attribute is Required
                                            </MDTypography>
                                        </div> : <></>
                                }
                                {
                                    activeServiceRequest &&
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${activeServiceRequest?.StatusOption?.BadgeDetail?.font_color ?? 'green'}`,
                                            alignItems: "center",
                                            backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                                        }}
                                    >
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: activeServiceRequest?.StatusOption?.BadgeDetail?.font_color ?? 'green',
                                                marginLeft: "10px",
                                            }}
                                        >
                                            {'Service ' + activeServiceRequest?.StatusOption?.StatusType?.status_name} -{" "}
                                            {activeServiceRequest?.StatusOption?.StatusType?.description} &middot;{" "}
                                            {moment(activeServiceRequest?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                }
                                {
                                    notifyAlert &&
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid yellow`,
                                            alignItems: "center",
                                            backgroundColor: '#ffff00ba'
                                            // backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                                        }}
                                    >
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: 'white',
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className='fa fa-bell'
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color: "#fff",
                                                }}
                                            ></i>{" "}
                                            {notifyAlert}
                                        </MDTypography>
                                    </div>
                                }
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    {overviewEnabled ? (
                                        <ChannelDetailCard
                                            id="gateway-channel-detail"
                                            embedded
                                            channel={selectedChannelModel}
                                            channels={channelModels}
                                            onStep={stepChannel}
                                            visual={
                                                isStateAvail ? (
                                                    <MDBox
                                                        sx={(theme) => ({
                                                            ...nestedSurfaceSx(theme),
                                                            p: 1.25,
                                                            height: "100%",
                                                            minHeight: 300,
                                                        })}
                                                    >
                                                        <ParamType
                                                            param={memoizedParam}
                                                            alert={activeAlerts}
                                                            deviceFields={deviceSetupFields}
                                                        />
                                                    </MDBox>
                                                ) : null
                                            }
                                        />
                                    ) : (
                                        <>
                                            <MDBox>
                                                <MDTypography>Level</MDTypography>
                                                <MDBox style={{ position: "relative" }}>
                                                    <StyledLinearProgress
                                                        variant="determinate"
                                                        value={percent}
                                                    />
                                                    <MDBox
                                                        position="absolute"
                                                        top={0}
                                                        left={0}
                                                        right={0}
                                                        bottom={0}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        color={percent == '-' ? "white" : percent > 49 ? "white" : "black"}
                                                    >
                                                        <MDTypography variant="body2" color="textSecondary">
                                                            {percent == '-' ? percent : `${percent}%`}
                                                        </MDTypography>
                                                    </MDBox>
                                                </MDBox>
                                            </MDBox>
                                            <MDBox
                                                display="flex"
                                                flexDirection={{ xs: "column", md: "row" }}
                                                justifyContent="space-between"
                                                alignItems="stretch"
                                                gap={3}
                                                width="100%"
                                            >
                                                <MDBox flex={1} minWidth={{ xs: "0", md: isStateAvail ? "50%" : '100%' }}>
                                                    <ParamValuesChartForHolyKel
                                                        paramValues={paramValues}
                                                        pillbarColor={pillbarColor}
                                                        channel_id={defaultChannel}
                                                    />
                                                </MDBox>
                                                {isStateAvail && (
                                                    <MDBox
                                                        flex={1}
                                                        minWidth={{ xs: "0", md: "49%" }}
                                                    >
                                                        <MDBox mt={5} mb={5}>
                                                            <div
                                                                style={{
                                                                    backgroundColor: "rgb(38, 40, 51)",
                                                                    padding: "10px",
                                                                    borderRadius: "10px",
                                                                    height: '300px',
                                                                    width: '100%'
                                                                }}
                                                            >
                                                                <ParamType param={memoizedParam} alert={activeAlerts} deviceFields={deviceSetupFields} />
                                                            </div>
                                                        </MDBox>
                                                    </MDBox>
                                                )}
                                            </MDBox>
                                        </>
                                    )}
                                    <LinkedVehicleCard
                                        vehicles={linkedVehicles}
                                        device={device}
                                        deviceSetupFields={deviceSetupFields}
                                        paramValue={paramValue}
                                        selectedId={selectedLinkedVehicleId}
                                        onSelect={setSelectedLinkedVehicleId}
                                    />
                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Device Information",
                                                    icon: "fas fa-info-circle",
                                                },
                                                { title: "Current Data", icon: "fas fa-chart-line" },
                                                { title: "Monitor", icon: "fas fa-tachometer-alt" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index}>
                                                    <Card style={cardStyle(index)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index)}
                                                        />
                                                        {expandedIndexArray[index] && (
                                                            <CardContent
                                                                style={
                                                                    isTabletOrMobile
                                                                        ? { padding: "16px", flex: 1 }
                                                                        : { flex: 1 }
                                                                }
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "end",
                                                                                mb: 2,
                                                                            }}
                                                                        >
                                                                            <MDButton
                                                                                variant="gradient"
                                                                                color="dark"
                                                                                size="small"
                                                                                px={2}
                                                                                mx={2}
                                                                                onClick={() =>

                                                                                    handleOpenDeviceInfoEditModal()

                                                                                }
                                                                            >
                                                                                Edit
                                                                            </MDButton>
                                                                            &nbsp;
                                                                            {
                                                                                !(deviceSetupFields?.latitude ||
                                                                                    deviceSetupFields?.longitude) ?
                                                                                    <MDButton
                                                                                        variant="gradient"
                                                                                        color="dark"
                                                                                        size="small"
                                                                                        px={2}
                                                                                        mx={2}
                                                                                        onClick={() =>

                                                                                            openModalFn("itemButton")

                                                                                        }
                                                                                    >
                                                                                        Select Location
                                                                                    </MDButton> : <></>
                                                                            }
                                                                        </Box>

                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {name?.text}
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes?.DeviceType
                                                                                                        ?.type_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Brand:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceBrand?.brand_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Model:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceModel?.model_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Item Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    renderText('item_type')
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>
                                                                                                    Entity Address Item Id:
                                                                                                </strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    renderText('entity_address_item')
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>
                                                                                                    Entity Address Id:
                                                                                                </strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Address
                                                                                                        ?.address_id
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Item Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    renderText('item_name')
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Item Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    renderText('item_type_name')
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Address Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Address
                                                                                                        ?.name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Address:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {renderText('address')}
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Status / Mode:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.StatusOption?.StatusType
                                                                                                        ?.status_name
                                                                                                } / {
                                                                                                    selectedMode?.mode_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {deviceSetupFields?.latitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Latitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.latitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                    {deviceSetupFields?.longitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Longitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.longitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {window.innerWidth > 600 && (
                                                                            <Box sx={{ display: "flex", justifyContent: "end", mb: 5.5 }} />
                                                                        )}

                                                                        {loader && <StackSkeleton />}

                                                                        <Table
                                                                            style={{
                                                                                ...styles.table,
                                                                                marginTop: "5px",
                                                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                                            }}
                                                                        >
                                                                            <TableBody>
                                                                                {!loader && (
                                                                                    <>
                                                                                        {/* Pressure / Fluid Height */}
                                                                                        <DataRow
                                                                                            label={isPressure ? "Pressure (PSI):" : "Fluid Height:"}
                                                                                            value={`${paramValue?.data?.actual_fluid_height} Inches`}
                                                                                            styles={styles}
                                                                                        />

                                                                                        {/* State */}
                                                                                        {isStateAvail && (
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>State:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>

                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <i
                                                                                                            className={paramValue?.data?.state?.icon?.class_name}
                                                                                                            style={{ marginRight: 8 }}
                                                                                                        />
                                                                                                        <span
                                                                                                            style={{
                                                                                                                color: paramValue?.data?.state?.display_color,
                                                                                                            }}
                                                                                                        >
                                                                                                            {paramValue?.data?.state?.display_label}
                                                                                                        </span>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        )}

                                                                                        {/* Calibrated */}
                                                                                        <DataRow
                                                                                            label={`Calibrated ${isPressure ? "Pressure" : "Level"}:`}
                                                                                            value={paramValue?.data?.calibrated_level}
                                                                                            styles={styles}
                                                                                        />

                                                                                        {/* Level Information */}
                                                                                        {!isPressure && (
                                                                                            <>
                                                                                                <DataRow
                                                                                                    label="Percent Level:"
                                                                                                    value={paramValue?.data?.fill_percentage}
                                                                                                    styles={styles}
                                                                                                />

                                                                                                <DataRow
                                                                                                    label="Usable Height:"
                                                                                                    value={paramValue?.data?.usable_height}
                                                                                                    styles={styles}
                                                                                                />

                                                                                                <DataRow
                                                                                                    label="Volume:"
                                                                                                    value={`${paramValue?.data?.volume_level} Gallons`}
                                                                                                    styles={styles}
                                                                                                />

                                                                                                {isUllageApplicable(paramValue?.data, paramValue?.device_setup?.shape) && (
                                                                                                    <>
                                                                                                        <DataRow
                                                                                                            label="Ullage Volume:"
                                                                                                            value={getUllageStateText(paramValue?.data) === null
                                                                                                                ? `${formatUllageVolume(paramValue?.data)} US gal (estimated; not a safe delivery quantity)`
                                                                                                                : `${formatUllageVolume(paramValue?.data)} (${getUllageStateText(paramValue?.data)})`}
                                                                                                            styles={styles}
                                                                                                        />
                                                                                                        <DataRow
                                                                                                            label="Ullage Height:"
                                                                                                            value={getUllageStateText(paramValue?.data) === null
                                                                                                                ? `${formatUllageHeight(paramValue?.data)} inches`
                                                                                                                : formatUllageHeight(paramValue?.data)}
                                                                                                            styles={styles}
                                                                                                        />
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        )}

                                                                                        {/* pt100 sensor */}
                                                                                        {
                                                                                            paramValue?.pt100 && (
                                                                                                <>
                                                                                                    <DataRow
                                                                                                        label="PT100 1:"
                                                                                                        value={formatTemp(paramValue?.pt100?.pt100_1)}
                                                                                                        styles={styles}
                                                                                                        valueStyles = {{ color: getTempColor(paramValue?.pt100?.pt100_1) }}
                                                                                                    />
                                                                                                    <DataRow
                                                                                                        label="PT100 2:"
                                                                                                        value={formatTemp(paramValue?.pt100?.pt100_2)}
                                                                                                        styles={styles}
                                                                                                        valueStyles = {{ color: getTempColor(paramValue?.pt100?.pt100_2) }}
                                                                                                    />
                                                                                                </>
                                                                                            )
                                                                                        }

                                                                                        {/* gpio input */}
                                                                                        {
                                                                                            paramValue?.raw_data && (
                                                                                                <>
                                                                                                    <DataRow
                                                                                                        label="Gpio Input 1:"
                                                                                                        value={paramValue?.raw_data?.gpio_input_1}
                                                                                                        styles={styles}
                                                                                                        valueStyles = {{ color: paramValue?.raw_data?.gpio_input_1 == 'on' ? '#07ff07' : 'red' }}
                                                                                                    />
                                                                                                    <DataRow
                                                                                                        label="Gpio Input 2:"
                                                                                                        value={paramValue?.raw_data?.gpio_input_2}
                                                                                                        styles={styles}
                                                                                                        valueStyles = {{ color: paramValue?.raw_data?.gpio_input_2 == 'on' ? '#07ff07' : 'red' }}
                                                                                                    />
                                                                                                    <DataRow
                                                                                                        label="Gpio Input 3:"
                                                                                                        value={paramValue?.raw_data?.gpio_input_3}
                                                                                                        styles={styles}
                                                                                                        valueStyles = {{ color: paramValue?.raw_data?.gpio_input_3 == 'on' ? '#07ff07' : 'red' }}
                                                                                                    />
                                                                                                    <DataRow
                                                                                                        label="Gpio Input 4:"
                                                                                                        value={paramValue?.raw_data?.gpio_input_4}
                                                                                                        styles={styles}
                                                                                                        valueStyles = {{ color: paramValue?.raw_data?.gpio_input_4 == 'on' ? '#07ff07' : 'red' }}
                                                                                                    />
                                                                                                </>
                                                                                            )
                                                                                        }

                                                                                        {/* Address Coordinates */}
                                                                                        {device?.attributes?.EntityAddressItem?.Address?.latitude ? (
                                                                                            <ClickableRow
                                                                                                label="Address Latitude:"
                                                                                                value={
                                                                                                    device?.attributes?.EntityAddressItem?.Address?.latitude
                                                                                                }
                                                                                                onClick={() => openModalFn("address")}
                                                                                                styles={styles}
                                                                                            />
                                                                                        ) : ''}

                                                                                        {device?.attributes?.EntityAddressItem?.Address?.longitude ? (
                                                                                            <ClickableRow
                                                                                                label="Address Longitude:"
                                                                                                value={
                                                                                                    device?.attributes?.EntityAddressItem?.Address?.longitude
                                                                                                }
                                                                                                onClick={() => openModalFn("address")}
                                                                                                styles={styles}
                                                                                            />
                                                                                        ) : ''}

                                                                                        {/* Device Coordinates */}
                                                                                        {paramValue?.parsed_ansi?.latitude ? (
                                                                                            <ClickableRow
                                                                                                label="Device Latitude:"
                                                                                                value={Number(
                                                                                                    paramValue?.parsed_ansi?.latitude
                                                                                                ).toFixed(8)}
                                                                                                onClick={() => openModalFn("device")}
                                                                                                styles={styles}
                                                                                            />
                                                                                        ) : ''}

                                                                                        {paramValue?.parsed_ansi?.longitude ? (
                                                                                            <ClickableRow
                                                                                                label="Device Longitude:"
                                                                                                value={Number(
                                                                                                    paramValue?.parsed_ansi?.longitude
                                                                                                ).toFixed(8)}
                                                                                                onClick={() => openModalFn("device")}
                                                                                                styles={styles}
                                                                                            />
                                                                                        ) : ''}

                                                                                        {/* Last Updated */}
                                                                                        {paramValue?.parsed_ansi?.longitude !== 0 &&
                                                                                            paramValue?.parsed_ansi?.latitude !== 0 &&
                                                                                            paramValue?.last_updated ? (
                                                                                            <DataRow
                                                                                                label="Last Updated:"
                                                                                                value={moment(paramValue.last_updated).format(
                                                                                                    "MMMM Do YYYY, h:mm:ss a"
                                                                                                )}
                                                                                                styles={styles}
                                                                                            />
                                                                                        ) : ''}

                                                                                        {/* Job State */}
                                                                                        {jobStateData && (
                                                                                            <>
                                                                                                <DataRow
                                                                                                    label="Job State:"
                                                                                                    value={jobStateData.from_state}
                                                                                                    styles={styles}
                                                                                                />

                                                                                                <DataRow
                                                                                                    label="Job State Reason:"
                                                                                                    value={jobStateData.reason}
                                                                                                    styles={styles}
                                                                                                />

                                                                                                <DataRow
                                                                                                    label="Job State Time:"
                                                                                                    value={moment(jobStateData.timestamp).format(
                                                                                                        "MMMM DD, YYYY h:mm:ss A"
                                                                                                    )}
                                                                                                    styles={styles}
                                                                                                />
                                                                                            </>
                                                                                        )}

                                                                                        {/* Linked Devices */}
                                                                                        {linkedDeviceData.length > 0 &&
                                                                                            linkedDeviceData.map((value) => (
                                                                                                <LinkedDeviceView
                                                                                                    key={value?.device_id}
                                                                                                    data={value}
                                                                                                    styles={styles}
                                                                                                    onShowOnMap={
                                                                                                        mappableVehicleIds.has(String(value?.device_id))
                                                                                                            ? showLinkedVehicleOnMap
                                                                                                            : undefined
                                                                                                    }
                                                                                                />
                                                                                            ))}
                                                                                    </>
                                                                                )}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                            }}
                                                                        >
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch
                                                                                        checked={isNotified}
                                                                                        onChange={(e) => {
                                                                                            setNotified(!isNotified);
                                                                                            CrudService.setDeviceAlertEnable({
                                                                                                deviceId: id,
                                                                                                is_notified: !isNotified,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label="Alerts Enabled"
                                                                                mt={5}
                                                                                mb={5}
                                                                            />
                                                                            <MDButton
                                                                                variant="gradient"
                                                                                color="dark"
                                                                                size="small"
                                                                                px={2}
                                                                                mx={2}
                                                                                onClick={handleOpenMonitorEditModal}
                                                                            >
                                                                                Edit
                                                                            </MDButton>
                                                                        </Box>
                                                                        {loader && <StackSkeleton />}
                                                                        {!loader && (
                                                                            <MDBox>
                                                                                <table className="table table-borderless">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <RenderTR
                                                                                                th={"Name"}
                                                                                                td={device?.monitor}
                                                                                                styles={styles}
                                                                                            />
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_status
                                                                                                ?.StatusType?.status_name && (
                                                                                                    <RenderTR
                                                                                                        th={"Status"}
                                                                                                        styles={styles}
                                                                                                        td={
                                                                                                            <Badge
                                                                                                                color={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail
                                                                                                                        ?.color || "primary"
                                                                                                                }
                                                                                                                variant={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail?.variant
                                                                                                                }
                                                                                                                badgeContent={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.StatusType
                                                                                                                        ?.status_name
                                                                                                                }
                                                                                                                style={{
                                                                                                                    marginLeft: "30px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        }
                                                                                                    />
                                                                                                )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_frequency && (
                                                                                                <RenderTR
                                                                                                    styles={styles}
                                                                                                    th={"Frequency"}
                                                                                                    td={`${device?.monitor_frequency ??
                                                                                                        ""
                                                                                                        } ${device?.monitor_time_unit ??
                                                                                                        ""
                                                                                                        }`}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_last_updated && (
                                                                                                <RenderTR
                                                                                                    styles={styles}
                                                                                                    th={"Last Updated"}
                                                                                                    td={moment(
                                                                                                        device?.monitor_last_updated
                                                                                                    ).format(
                                                                                                        "MMMM Do YYYY, h:mm:ss a"
                                                                                                    )}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>

                                                                                {selectedChannelThresholds.map(
                                                                                    (threshold, thresholdIndex) => (
                                                                                        <Table
                                                                                            key={thresholdIndex + 3}
                                                                                            style={{
                                                                                                ...styles.table,
                                                                                                marginTop: "5px",
                                                                                                boxShadow:
                                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                            }}
                                                                                        >
                                                                                            <TableBody>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Alert Type:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.AlertType
                                                                                                                    ?.type_name
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Parameter
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.DeviceParameter
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Comparison Operator:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.ComparisonOperator
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Threshold Comparison
                                                                                                                Value:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.threshold_value
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    )
                                                                                )}
                                                                            </MDBox>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                { title: "Transmission", icon: "fas fa-signal" },
                                                { title: "Analytics", icon: "fas fa-chart-diagram" },
                                                { title: "Providers", icon: "fas fa-truck" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 3}>
                                                    <Card style={cardStyle(index + 3)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 3)}
                                                        />
                                                        {expandedIndexArray[index + 3] && (
                                                            <CardContent style={{ flex: 1 }}>
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    {!loader && (
                                                                                        <>
                                                                                            {deviceStatusName && (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <strong>Status:</strong>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        {deviceStatusName ===
                                                                                                            "Working" ? (
                                                                                                            <Badge
                                                                                                                variant="gradient"
                                                                                                                badgeContent={
                                                                                                                    deviceStatusName
                                                                                                                }
                                                                                                                color="success"
                                                                                                                style={{
                                                                                                                    marginLeft: "40px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        ) : deviceStatusName !==
                                                                                                            "" ? (
                                                                                                            <Badge
                                                                                                                variant="gradient"
                                                                                                                badgeContent={
                                                                                                                    deviceStatusName
                                                                                                                }
                                                                                                                color="error"
                                                                                                                style={{
                                                                                                                    marginLeft: "-60px",
                                                                                                                    width: "120px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        ) : (
                                                                                                            ""
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Signal Strength:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {paramValue?.signal_strength ?? '-'} dBm
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Reported:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {(() => {
                                                                                                            const time = moment(
                                                                                                                paramValue?.last_checked ??
                                                                                                                deviceUpdated
                                                                                                            );
                                                                                                            const dateFormat = "MMM Do YYYY, ";
                                                                                                            // If the hour is 12 PM or later, show 'PM'. Otherwise, omit 'AM'.
                                                                                                            const timeFormat = time.hour() >= 12 ? "h:mm A" : "h:mm";
                                                                                                            return time.format(dateFormat + timeFormat);
                                                                                                        })()}
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>
                                                                                                            Last Updated:
                                                                                                        </strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {moment(
                                                                                                            paramValue?.last_updated ??
                                                                                                            deviceUpdated
                                                                                                        ).fromNow()}
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                            {paramValue?.reportType && (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <strong>
                                                                                                                Report Type:
                                                                                                            </strong>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                reportType[
                                                                                                                paramValue?.reportType
                                                                                                                ]
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {!loader && analysisData ? (
                                                                            <>
                                                                                {/* Last 24h Section */}
                                                                                <Box sx={{ marginBottom: 2 }}>
                                                                                    <TableSection
                                                                                        title="Last 24 Hours"
                                                                                        styles={styles}
                                                                                        rowData={[
                                                                                            {
                                                                                                label: "Percent Change",
                                                                                                value: analysisData[defaultChannel]?.last_24_hours?.percent_change ?? 0,
                                                                                                unit: "%",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Level Change",
                                                                                                value: analysisData[defaultChannel]?.last_24_hours?.inch_change ?? 0,
                                                                                                unit: " inches",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Volume Change",
                                                                                                value: analysisData[defaultChannel]?.last_24_hours?.volume_change ?? 0,
                                                                                                unit: " gal",
                                                                                                renderType: "text",
                                                                                            },
                                                                                        ]}
                                                                                    />
                                                                                </Box>

                                                                                {/* Last 7 Days Section */}
                                                                                <Box sx={{ marginBottom: 2 }}>
                                                                                    <TableSection
                                                                                        title="Last 7 Days"
                                                                                        styles={styles}
                                                                                        rowData={[
                                                                                            {
                                                                                                label: "Percent Change",
                                                                                                value: analysisData[defaultChannel]?.last_7_days?.percent_change ?? 0,
                                                                                                unit: "%",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Level Change",
                                                                                                value: analysisData[defaultChannel]?.last_7_days?.inch_change ?? 0,
                                                                                                unit: " inches",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Volume Change",
                                                                                                value: analysisData[defaultChannel]?.last_7_days?.volume_change ?? 0,
                                                                                                unit: " gal",
                                                                                                renderType: "text",
                                                                                            },
                                                                                        ]}
                                                                                    />
                                                                                </Box>

                                                                                {/* AI Analysis Section */}
                                                                                {device?.analysis && (
                                                                                    <Box sx={{ marginBottom: 2 }}>
                                                                                        <TableSection
                                                                                            title="AI Analysis"
                                                                                            styles={styles}
                                                                                            // rowData={Object.entries(device.analysis).map(([label, value]) => ({
                                                                                            //   label,
                                                                                            //   value,
                                                                                            //   renderType:
                                                                                            //     label === "Trend" || label === "Status" || label === "Anomalies" ? "icon" : "text",
                                                                                            // }))}
                                                                                            rowData={[
                                                                                                {
                                                                                                    label: "Trend",
                                                                                                    value:
                                                                                                        device?.analysis?.Trend,
                                                                                                    renderType: "icon",
                                                                                                },
                                                                                                {
                                                                                                    label: "Status",
                                                                                                    value:
                                                                                                        device?.analysis?.Status,
                                                                                                    renderType: "icon",
                                                                                                },
                                                                                                {
                                                                                                    label: `${capitalizeWords(
                                                                                                        device?.analysis[
                                                                                                        "Estimated Type"
                                                                                                        ] || ""
                                                                                                    )} Date`,
                                                                                                    value: ![
                                                                                                        0,
                                                                                                        null,
                                                                                                        undefined,
                                                                                                        "",
                                                                                                    ].includes(
                                                                                                        device?.analysis?.[
                                                                                                        "Estimated Time (Days)"
                                                                                                        ]
                                                                                                    )
                                                                                                        ? calculateFullDate(
                                                                                                            device.analysis[
                                                                                                            "Estimated Time (Days)"
                                                                                                            ]
                                                                                                        )
                                                                                                        : "None",
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: `Days Until ${capitalizeWords(
                                                                                                        device?.analysis[
                                                                                                        "Estimated Type"
                                                                                                        ] || ""
                                                                                                    )}`,
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Estimated Time (Days)"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: "Estimated Type",
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Estimated Type"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: "Anomalies",
                                                                                                    value:
                                                                                                        device?.analysis?.Anomalies,
                                                                                                    renderType: "icon",
                                                                                                },
                                                                                                {
                                                                                                    label:
                                                                                                        "Threshold Breach Prediction",
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Threshold Breach Prediction"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: "Reason",
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Reason"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                            ]}
                                                                                        />
                                                                                    </Box>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}

                                                                {index === 2 && (
                                                                    <>
                                                                        <MDBox>
                                                                            <Grid
                                                                                container
                                                                                justifyContent="space-between"
                                                                            >
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6">
                                                                                        Provider
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6" mr={3}>
                                                                                        Share
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            {!loader ? (
                                                                                <>
                                                                                    {device?.entityAddressItemProviders.map(
                                                                                        (provider) => (
                                                                                            <MDBox
                                                                                                key={provider?.association_id}
                                                                                                sx={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent:
                                                                                                        "space-between",
                                                                                                    width: "100%",
                                                                                                }}
                                                                                            >
                                                                                                <MDBox
                                                                                                    sx={{
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <Avatar
                                                                                                        src={
                                                                                                            provider?.Provider
                                                                                                                ?.logo_url
                                                                                                        }
                                                                                                        alt={
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                        sx={{
                                                                                                            width: 60,
                                                                                                            height: 60,
                                                                                                        }}
                                                                                                    />
                                                                                                    <MDTypography ml={2}>
                                                                                                        {
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </MDBox>
                                                                                                <FormControlLabel
                                                                                                    control={
                                                                                                        <Switch
                                                                                                            checked={
                                                                                                                providersState.find(
                                                                                                                    (p) =>
                                                                                                                        p.association_id ===
                                                                                                                        provider.association_id
                                                                                                                )?.on_off
                                                                                                            }
                                                                                                            onChange={async (e) => {
                                                                                                                const newOnOffValue =
                                                                                                                    e.target.checked;
                                                                                                                await handleProviderSwitchChange(
                                                                                                                    provider.association_id,
                                                                                                                    newOnOffValue
                                                                                                                );
                                                                                                            }}
                                                                                                        />
                                                                                                    }
                                                                                                    label=""
                                                                                                    sx={{
                                                                                                        mt: 5,
                                                                                                        mb: 5,
                                                                                                    }}
                                                                                                />
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Contact Detail",
                                                    icon: "fas fa-address-book",
                                                },
                                                {
                                                    title: "Device Setup",
                                                    icon: "fas fa-wrench",
                                                },
                                                { title: "Actions", icon: "fas fa-cogs" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 6}>
                                                    <Card style={cardStyle(index + 6)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 6)}
                                                        />
                                                        {expandedIndexArray[index + 6] && (
                                                            <CardContent
                                                                style={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                }}
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        {
                                                                            checkAccess() &&
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    justifyContent: "end",
                                                                                }}
                                                                            >
                                                                                <MDButton
                                                                                    variant="gradient"
                                                                                    color="dark"
                                                                                    size="small"
                                                                                    px={2}
                                                                                    mx={2}
                                                                                    onClick={
                                                                                        handleOpenContactsDetailsEditModal
                                                                                    }
                                                                                >
                                                                                    Edit
                                                                                </MDButton>
                                                                            </Box>
                                                                        }
                                                                        {!loader ? (
                                                                            <>
                                                                                {device &&
                                                                                    device.contacts &&
                                                                                    device.contacts.map(
                                                                                        (contact, contactindex) => (
                                                                                            <MDBox key={contactindex + 6}>
                                                                                                <Table
                                                                                                    style={{
                                                                                                        ...styles.table,
                                                                                                        marginTop: "5px",
                                                                                                        boxShadow:
                                                                                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                                    }}
                                                                                                >
                                                                                                    <TableBody>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Contact Name:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {`${contact?.Contact?.first_name} ${contact?.Contact?.last_name}`}
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Access Type:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.access_type?.toUpperCase()
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Status:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.Contact
                                                                                                                            ?.StatusOption
                                                                                                                            ?.StatusType
                                                                                                                            ?.status_name
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        {contact?.Contact
                                                                                                            ?.ContactAddresses &&
                                                                                                            contact?.Contact?.ContactAddresses.map(
                                                                                                                (address, subindex) => (
                                                                                                                    <TableRow
                                                                                                                        key={subindex + 6}
                                                                                                                    >
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                <span
                                                                                                                                    style={{
                                                                                                                                        fontWeight:
                                                                                                                                            "700",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {" "}
                                                                                                                                    {
                                                                                                                                        address
                                                                                                                                            ?.ContactAddressType
                                                                                                                                            ?.type_name
                                                                                                                                    }
                                                                                                                                    :{" "}
                                                                                                                                </span>
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    address?.contact_address
                                                                                                                                }
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                    </TableRow>
                                                                                                                )
                                                                                                            )}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                            </>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "end",
                                                                            }}
                                                                        >
                                                                            <MDButton
                                                                                variant="gradient"
                                                                                color="dark"
                                                                                size="small"
                                                                                px={2}
                                                                                mx={2}
                                                                                onClick={handleOpenDeviceSetupEditModal}
                                                                            >
                                                                                Edit
                                                                            </MDButton>
                                                                        </Box>
                                                                        <MDBox>
                                                                            {!loader ? (
                                                                                <Box sx={{ marginBottom: 2 }}>
                                                                                    <Box sx={{ marginBottom: 2 }}>
                                                                                        <Table
                                                                                            style={{
                                                                                                ...styles.table,
                                                                                                marginTop: "5px",
                                                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                            }}
                                                                                        >
                                                                                            <MDTypography fontSize={1}>
                                                                                                <span style={{ fontWeight: "700" }}>Device Item</span>
                                                                                            </MDTypography>
                                                                                            <TableBody>
                                                                                                {/* Render Device Setup Fields */}
                                                                                                {[
                                                                                                    {
                                                                                                        label: "Depth",
                                                                                                        value: deviceSetupFields?.depth,
                                                                                                    },
                                                                                                    {
                                                                                                        label: "Width",
                                                                                                        value: deviceSetupFields?.width,
                                                                                                    },
                                                                                                    {
                                                                                                        label: "Length",
                                                                                                        value:
                                                                                                            deviceSetupFields?.length,
                                                                                                    },
                                                                                                    {
                                                                                                        label: "Shape",
                                                                                                        value: deviceSetupFields?.shape,
                                                                                                    },
                                                                                                ].map(
                                                                                                    (field, index) =>
                                                                                                        field.value && (
                                                                                                            <TableRow
                                                                                                                key={`setup-${index}`}
                                                                                                            >
                                                                                                                <TableCell
                                                                                                                    style={styles.cell}
                                                                                                                >
                                                                                                                    <MDTypography
                                                                                                                        fontSize={1}
                                                                                                                    >
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                fontWeight: "700",
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {field.label}:
                                                                                                                        </span>
                                                                                                                    </MDTypography>
                                                                                                                </TableCell>
                                                                                                                <TableCell
                                                                                                                    style={styles.cell}
                                                                                                                >
                                                                                                                    <MDTypography
                                                                                                                        fontSize={1}
                                                                                                                    >
                                                                                                                        {field.value}
                                                                                                                    </MDTypography>
                                                                                                                </TableCell>
                                                                                                            </TableRow>
                                                                                                        )
                                                                                                )}

                                                                                                {/* Render Device Identifier Values */}
                                                                                                {device.attributes?.DeviceIdentifierValues?.map(
                                                                                                    (e, i) => (
                                                                                                        <TableRow
                                                                                                            key={`identifier-${i}`}
                                                                                                        >
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1}>
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {
                                                                                                                            e.DeviceIdentifierType
                                                                                                                                .identifier_type_name
                                                                                                                        }
                                                                                                                        :
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1}>
                                                                                                                    {e.value}
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                    )
                                                                                                )}

                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                Public Share Device:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {/* {device.attributes?.PublicShareDevice} */}
                                                                                                            <Switch
                                                                                                                checked={isShare}
                                                                                                                onChange={(e) => {
                                                                                                                    handlePublicDeviceShare(e)
                                                                                                                }}
                                                                                                                title={isShare ? 'Public sharing is enabled' : 'Enable public sharing to generate a shareable link'}
                                                                                                            />
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                {
                                                                                                    isShare ?
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1}>
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Public Share Device URL:
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1} style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(`${location.origin}/device/public/${device.attributes?.PublicShareDevice?.public_uuid}`)}>
                                                                                                                    🔗
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        : <></>
                                                                                                }

                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    </Box>
                                                                                    {
                                                                                        paramValue?.device_setup_details ?
                                                                                            <>
                                                                                                <MDBox sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <span style={{ fontWeight: "700" }}>Device Setting</span>
                                                                                                    </MDTypography>
                                                                                                    <MDButton
                                                                                                        variant="gradient"
                                                                                                        color="dark"
                                                                                                        size="small"
                                                                                                        px={2}
                                                                                                        mx={2}
                                                                                                        onClick={() => setOpenDeviceSettingModal(true)}
                                                                                                    >
                                                                                                        Update
                                                                                                    </MDButton>
                                                                                                </MDBox>
                                                                                                <Table
                                                                                                    style={{
                                                                                                        ...styles.table,
                                                                                                        marginTop: "5px",
                                                                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                                    }}
                                                                                                >
                                                                                                    <TableBody>
                                                                                                        {(!loader && parameters.length && paramValue?.device_setup_details) ? (
                                                                                                            parameters.map((e) => {
                                                                                                                if (show_device_setting.includes(e.parameter_name) && !cond.includes(paramValue.device_setup_details[e.parameter_name])) {
                                                                                                                    return (
                                                                                                                        <React.Fragment key={e.parameter_name}>
                                                                                                                            <TableRow key={e.parameter_name}>
                                                                                                                                <TableCell
                                                                                                                                    style={styles.cell}
                                                                                                                                    title={e.tooltip}
                                                                                                                                >
                                                                                                                                    <MDTypography fontSize={1}>
                                                                                                                                        <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                                            {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                                            {e.label}:
                                                                                                                                        </strong>
                                                                                                                                    </MDTypography>
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    style={styles.cell}
                                                                                                                                >
                                                                                                                                    <MDTypography fontSize={1}>
                                                                                                                                        {formatValue(paramValue.device_setup_details[`convert_${e.parameter_name}`] ?? paramValue.device_setup_details[e.parameter_name], e.format ?? '', e.display_ui ?? '')}
                                                                                                                                    </MDTypography>
                                                                                                                                </TableCell>
                                                                                                                            </TableRow>
                                                                                                                        </React.Fragment>
                                                                                                                    );
                                                                                                                }
                                                                                                                return <></>;
                                                                                                            })
                                                                                                        ) : ''}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                            </>
                                                                                            : ''
                                                                                    }
                                                                                </Box>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                        <MDButton
                                                                            color="dark"
                                                                            onClick={() => {
                                                                                setServiceRequestEditFlag(false);
                                                                                setServiceModal(true);
                                                                                setServiceRequest(null);
                                                                            }}
                                                                        >
                                                                            Create Service Request
                                                                        </MDButton>
                                                                        {percent >= 20 && percent <= 80 && (
                                                                            <MDButton
                                                                                color="info"
                                                                                sx={{
                                                                                    marginTop: "10px",
                                                                                }}
                                                                                onClick={() => {
                                                                                    setCalibrateDeviceModal(true);
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    id="calibrate-icon"
                                                                                    className="fas fa-cog"
                                                                                    style={{ marginRight: "5px" }}
                                                                                ></i>
                                                                                Calibrate Device
                                                                            </MDButton>
                                                                        )}

                                                                        {deviceStatusName == "Working" && (
                                                                            <MDButton
                                                                                color="error"
                                                                                sx={{
                                                                                    marginTop: "10px",
                                                                                }}
                                                                                onClick={() => {
                                                                                    setDeviceDisconnectModal(true);
                                                                                }}
                                                                            >
                                                                                Disconnect Device
                                                                            </MDButton>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <Modal
                                        open={openViewModal}
                                        onClose={handleViewClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: "80%", // Set the desired width here
                                                backgroundColor: "white",
                                                p: 4,
                                            }}
                                        >
                                            <AlertRulesForm
                                                alertRule={alertRule}
                                                // setAlertRules={setAlertRules}
                                                setAlertRules={(data) => updateNewRules(data)}
                                                deviceId={id}
                                                setOpenViewModal={setOpenViewModal}
                                            />
                                        </Card>
                                    </Modal>
                                    {/* multi status edit modal */}
                                    <Modal
                                        open={multiStatusEditModal}
                                        onClose={handleCloseMultiStatusEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <MultiSeviceRequestStatusEditForm
                                                selectedRowsIdArray={selectedRowsIdArray}
                                                setMultiStatusEditModal={setMultiStatusEditModal}
                                                serviceRequestId={serviceRequestId}
                                                setDataTableUpdate={setDataTableUpdate}
                                                selectedRequestType={selectedRequestType}
                                                showToast={showToast}
                                                totalServiceRequestManagement={false}
                                            />
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openMonitorEditModal}
                                        onClose={handleCloseMonitorEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <MDBox
                                                component="form"
                                                method="POST"
                                                onSubmit={handleSubmitMonitorEdit}
                                            >
                                                <Thresholds
                                                    selectedThresholds={selectedThresholds}
                                                    setSelectedThresholds={setSelectedThresholds}
                                                    type="edit"
                                                    model_id={device?.attributes?.DeviceModel?.model_id}
                                                    setRequiredThresholds={setRequiredThresholds}
                                                />
                                                <MDBox
                                                    ml="auto"
                                                    mt={3}
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                >
                                                    <MDButton
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={handleCloseMonitorEditModal}
                                                    >
                                                        Cancel
                                                    </MDButton>
                                                    <MDButton
                                                        variant="contained"
                                                        color="info"
                                                        type="submit"
                                                        style={{ marginLeft: "10px" }}
                                                    >
                                                        Save
                                                    </MDButton>
                                                </MDBox>
                                            </MDBox>
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openDeviceSettingModal}
                                        onClose={() => setOpenDeviceSettingModal(false)}
                                        aria-labelledby="modal-device-setting"
                                        aria-describedby="modal-device-setting-discription"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <UpdateDeviceSettings device_id={id} identifier={identifierValue} />
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openDeviceSetupEditModal}
                                        onClose={handleCloseDeviceSetupEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "1rem",
                                                }}
                                            >
                                                <TextField
                                                    label="Depth"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.depth}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            depth: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Width"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.width}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            width: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Length"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.length}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            length: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <Autocomplete
                                                    defaultValue=""
                                                    options={deviceSetupShapes}
                                                    value={deviceSetupFields.shape ?? null}
                                                    getOptionLabel={(option) => (option)}
                                                    isOptionEqualToValue={(option, value) => option === value}
                                                    onChange={(e, newStatus) => {
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            shape: newStatus,
                                                        }))
                                                    }}
                                                    renderInput={(params) => (
                                                        <FormField
                                                            {...params}
                                                            label="Shape"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            required
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <MDBox mt={3} display="flex" justifyContent="flex-end">
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleCloseDeviceSetupEditModal}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmitDeviceSetupEdit}
                                                >
                                                    Save
                                                </MDButton>
                                            </MDBox>
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={openDeviceInfoEditModal}
                                        onClose={handleCloseDeviceInfoEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "1rem",
                                                }}
                                            >
                                                <TextField
                                                    label="Device Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceName}
                                                    onChange={(e) =>
                                                        setDeviceName(e.target.value)
                                                    }
                                                />
                                                <TextField
                                                    label="Latitude"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.latitude}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            latitude: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Longitude"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.longitude}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            longitude: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Map Identifier"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={mapIdentifier}
                                                    onChange={(e) =>
                                                        setMapIdentifier(e.target.value)
                                                    }
                                                />
                                                <Autocomplete
                                                    defaultValue=""
                                                    options={modelist}
                                                    getOptionLabel={(option) =>
                                                        option ? option.mode_name : ''
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.mode_name === value}
                                                    value={selectedMode ?? ''}
                                                    onChange={(event, newMode) => {
                                                        setSelectedMode(newMode)
                                                    }}
                                                    renderInput={(params) => (
                                                        <FormField
                                                            {...params}
                                                            label="Mode"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            required
                                                        />
                                                    )}
                                                />
                                                <Autocomplete
                                                    defaultValue=""
                                                    options={iconList}
                                                    getOptionLabel={(option) =>
                                                        option ? option.class_name : ''
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.class_name === value}
                                                    value={selectedIcon ?? ''}
                                                    onChange={(event, newIcon) => {
                                                        setSelectedIcon(newIcon)
                                                    }}
                                                    renderOption={(props, option) => {
                                                        const { key, ...optionProps } = props;
                                                        return (
                                                            <Box key={key} component="li" {...optionProps}>
                                                                <i className={option.class_name} style={{ paddingRight: '5px' }}></i>
                                                                {option.icon_name}
                                                            </Box>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <FormField
                                                            {...params}
                                                            label="Icon"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            required
                                                        />
                                                    )}
                                                />
                                                {/* <TextField
                          label="Icon"
                          variant="outlined"
                          fullWidth
                          value={selectedIcon}
                          onChange={(e) =>
                            setSelectedIcon(e.target.value)
                          }
                        /> */}
                                            </div>
                                            <MDBox mt={3} display="flex" justifyContent="flex-end">
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleCloseDeviceInfoEditModal}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmitDeviceInformationEdit}
                                                >
                                                    Save
                                                </MDButton>
                                            </MDBox>
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openContactDetailsEditModal}
                                        onClose={handleCloseContactDetailsEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <ContactDeviceAccess selectedContactDeviceAccess={selectedContactDeviceAccess} entity_id={device?.attributes?.EntityAddressItem?.entity_id} address_item_id={device?.attributes?.EntityAddressItem?.address_item_id} />

                                            <MDBox
                                                ml="auto"
                                                mt={3}
                                                display="flex"
                                                justifyContent="flex-end"
                                            >
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleCloseContactDetailsEditModal}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmitContactDetailsEdit}
                                                >
                                                    Save
                                                </MDButton>
                                            </MDBox>
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={serviceRequestLogModal}
                                        onClose={handleServiceRequestModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",

                                                width: "80%", // Set the desired width here
                                                backgroundColor: "white",
                                                p: 4,
                                            }}
                                        >
                                            <ServiceRequestStatusLogForm
                                                setServiceRequestLogModal={setServiceRequestLogModal}
                                                logServiceRequestId={logServiceRequestId}
                                            />
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={calibrateDeviceModal}
                                        onClose={handleCalibrateDeviceModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%", md: "50%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                paddingTop: 1,
                                            }}
                                        >
                                            <CalibrateDeviceForm
                                                deviceName={name?.text}
                                                currentLevel={percent}
                                                // externalId = {device?.external_device_id}
                                                externalId={paramValue?.id}
                                                showToast={showToast}
                                                handleModalClose={handleCalibrateDeviceModalClose}
                                            />
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={deviceDisconnectModal}
                                        onClose={handleDeviceDisconnectModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%", md: "50%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                paddingTop: 1,
                                            }}
                                        >
                                            <DeviceDisconnectForm
                                                deviceName={name?.text}
                                                localIP={paramValue?.local_ip}
                                                // externalId = {device?.external_device_id}
                                                externalId={paramValue?.id}
                                                showToast={showToast}
                                                handleModalClose={handleDeviceDisconnectModalClose}
                                            />
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={openServiceModal}
                                        onClose={handleServiceModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" }, // Set the desired width here
                                                height: {
                                                    xs: "90vh",
                                                    sm: "90vh",
                                                    md: "700px",
                                                    lg: "700px",
                                                },
                                                backgroundColor: "white",
                                                paddingTop: "15px",
                                                paddingLeft: "10px",
                                                paddingRight: "10px",
                                                paddingBottom: "10px",
                                            }}
                                        >
                                            <ServiceRequestsForm
                                                deviceId={id}
                                                device={device?.attributes}
                                                serviceRequestEditFlag={serviceRequestEditFlag}
                                                serviceRequest={serviceRequest}
                                                setServiceModal={setServiceModal}
                                                setServiceRequests={setServiceRequests}
                                                setServiceStatusUpdate={setServiceStatusUpdate}
                                                showToast={showToast}
                                            />
                                        </Card>
                                    </Modal>
                                    <Modal open={openModal} onClose={() => setOpenModal(false)}>
                                        <MDBox tabIndex={-1}>
                                            <GoogleMapComponent
                                                lat={gps.latitude}
                                                lng={gps.longitude}
                                                edit={gps.edit}
                                                onLocationChange={handleLocationChange}
                                            />
                                        </MDBox>
                                    </Modal>
                                    <Modal
                                        open={phoneEnvModal}
                                        onClose={() => setPhoneEnvModal(false)}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",

                                                width: isTabletOrMobile ? "80%" : "20%", // Set the desired width here
                                                backgroundColor: "white",
                                                p: 4,
                                            }}
                                        >
                                            <MDTypography variant="h4" textAlign="center">
                                                Select Phone environment
                                            </MDTypography>
                                            <table className="table table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row" className="text-sm-end text-start">
                                                            <MDTypography fontSize={1}>
                                                                <span style={{ fontWeight: "700" }}>
                                                                    Production Phone:
                                                                </span>
                                                            </MDTypography>
                                                        </th>
                                                        <td style={styles.cell}>
                                                            <Switch
                                                                checked={phoneEnv.is_production}
                                                                onChange={(e) =>
                                                                    handlePhoneSwitch(
                                                                        e.target.checked,
                                                                        "is_production"
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-sm-end text-start">
                                                            <MDTypography fontSize={1}>
                                                                <span style={{ fontWeight: "700" }}>
                                                                    Sandbox Phone:
                                                                </span>
                                                            </MDTypography>
                                                        </th>
                                                        <td style={styles.cell}>
                                                            <Switch
                                                                checked={phoneEnv.is_sandbox}
                                                                onChange={(e) =>
                                                                    handlePhoneSwitch(
                                                                        e.target.checked,
                                                                        "is_sandbox"
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-sm-end text-start">
                                                            <MDTypography fontSize={1}>
                                                                <span style={{ fontWeight: "700" }}>
                                                                    Development Phone:
                                                                </span>
                                                            </MDTypography>
                                                        </th>
                                                        <td style={styles.cell}>
                                                            <Switch
                                                                checked={phoneEnv.is_development}
                                                                onChange={(e) =>
                                                                    handlePhoneSwitch(
                                                                        e.target.checked,
                                                                        "is_development"
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-evenly",
                                                }}
                                            >
                                                <MDButton
                                                    variant="gradient"
                                                    color="secondary"
                                                    size="small"
                                                    px={2}
                                                    my={2}
                                                    sx={{
                                                        marginLeft: "10px",
                                                    }}
                                                    onClick={() => setPhoneEnvModal(false)}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="gradient"
                                                    color="secondary"
                                                    size="small"
                                                    px={2}
                                                    my={2}
                                                    sx={{
                                                        marginLeft: "10px",
                                                    }}
                                                    onClick={clickSetPhoneOption}
                                                >
                                                    Save
                                                </MDButton>
                                            </div>
                                        </Card>
                                    </Modal>
                                    <Grid item xs={12} sm={8} lg={4}>
                                        <Tabs
                                            value={selectedTab}
                                            orientation={tabsOrientation}
                                            onChange={handleTabChange}
                                            aria-label="Tabs"
                                            sx={{ display: "flex" }}
                                        >
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-file-alt"
                                                            style={{ marginRight: "2px" }}
                                                        ></i>
                                                        Logs
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-exclamation-triangle"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Alerts
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fa-solid fa-clock"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Events
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-code-branch"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Rules
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1.5", p: "2" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-tools"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Service Request
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1.5", p: "2" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "0px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-tools"
                                                            style={{ marginRight: "0px" }}
                                                        ></i>
                                                        Jobs
                                                    </Box>
                                                }
                                            />
                                        </Tabs>
                                    </Grid>

                                    {selectedTab === 0 && Object.keys(reportType).length > 0 && (
                                        <LogsTable
                                            columns={dataTableData.columns}
                                            id={id}
                                            getRows={getRows}
                                            canSearch={true}
                                            canDelete={true}
                                            canExport={true}
                                            isSelection={true}
                                            exportFunc={clickExportLogsHandler}
                                        />
                                    )}
                                    {selectedTab === 1 && (
                                        <>
                                            <Modal
                                                open={openViewModal}
                                                onClose={handleViewClose}
                                                aria-labelledby="modal-title"
                                                aria-describedby="modal-description"
                                            >
                                                <Card
                                                    sx={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        width: "80%", // Set the desired width here
                                                        backgroundColor: "white",
                                                        boxShadow: 24,
                                                        p: 4,
                                                        maxHeight: "70vh", // Set max height to enable scrolling
                                                        overflowY: "auto",
                                                        overflowX: "hidden",
                                                    }}
                                                >
                                                    <CardContent>
                                                        <DynamicDataTable Alert={alert} />
                                                    </CardContent>
                                                </Card>
                                            </Modal>

                                            <MDBox pt={6} pb={3}>
                                                <MDBox mb={3}>
                                                    <CollapsibleTable
                                                        width="100%"
                                                        data={alertTableData}
                                                        columns={alertColumns}
                                                        clickViewHandler={clickViewHandler}
                                                        clickDeleteHandler={clickDeleteHandler}
                                                        page={page}
                                                        setPage={setPage}
                                                        rowsPerPage={rowsPerPage}
                                                        setRowsPerPage={setRowsPerPage}
                                                        count={countRef.current}
                                                    />
                                                </MDBox>
                                            </MDBox>
                                        </>
                                    )}
                                    {selectedTab === 2 && (
                                        <>
                                            <EventsTable
                                                columns={eventdataTableData.columns}
                                                id={id}
                                                getRows={getEventRows}
                                                canSearch={true}
                                                canDelete={true}
                                                isSelection={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 3 && (
                                        <>
                                            <MDBox
                                                p={3}
                                                lineHeight={1}
                                                display="flex"
                                                justifyContent="right"
                                            >
                                                <MDButton
                                                    color="dark"
                                                    size="small"
                                                    onClick={() => {
                                                        setAlertRule();
                                                        setOpenViewModal(true);
                                                    }}
                                                >
                                                    Add Rule
                                                </MDButton>
                                            </MDBox>
                                            <DataTable
                                                table={alertRuledataTableData}
                                                canSearch={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 4 && (
                                        <MDBox sx={{ marginTop: "20px" }}>
                                            <Can I="view" this={"phone"}>
                                                <MDBox>
                                                    <MDButton
                                                        variant={"gradient"}
                                                        color="primary"
                                                        size="small"
                                                        px={2}
                                                        my={2}
                                                        mx={2}
                                                        onClick={() => setPhoneEnvModal(true)}
                                                    >
                                                        Open Phone
                                                    </MDButton>
                                                </MDBox>
                                            </Can>
                                            {checkRowSelectedRowsFlag && (
                                                <MDBox>
                                                    <MDButton
                                                        variant="gradient"
                                                        color="primary"
                                                        size="small"
                                                        px={2}
                                                        my={2}
                                                        mx={2}
                                                        onClick={clickStatusEdit}
                                                    >
                                                        Edit
                                                    </MDButton>

                                                    <MDButton
                                                        variant="gradient"
                                                        color="secondary"
                                                        size="small"
                                                        px={2}
                                                        my={2}
                                                        sx={{
                                                            marginLeft: "10px",
                                                        }}
                                                        onClick={clickCancelSelection}
                                                    >
                                                        Cancel Selection
                                                    </MDButton>
                                                </MDBox>
                                            )}

                                            <ServiceRequestDataTable
                                                table={serviceRequestdataTableData}
                                                canSearch={true}
                                                onRowClick={clickServiceReqeustRowHandler}
                                                handleSelectedRows={handleSelectedRows}
                                                selectedRows={selectedRows}
                                                setDataTableUpdate={setDataTableUpdate}
                                            />
                                        </MDBox>
                                    )}
                                    {selectedTab === 5 && (
                                        <MDBox sx={{ marginTop: "20px" }}>
                                            <JobsTable
                                                 columns={JobTableColumns}
                                                 id={id}
                                                 getRows={getJobsRows}
                                                 canSearch={true}
                                                 canDelete={false}
                                                 isSelection={false}
                                            />
                                        </MDBox>
                                    )}

                                    <MDBox
                                        ml="auto"
                                        mt={4}
                                        mb={2}
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/devices", {
                                                        state: {
                                                            value: false,
                                                            text: "",
                                                        },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <JsonTree open={selectedLogInfo} onClose={() => setSelectedLogInfo(null)} data={selectedLogInfo} darkTheme={true} />
            <JsonTree open={openJsonTree} onClose={() => setJsonTree(false)} data={rawDataValue} />
            <Dialog
                open={deviceLogModel}
                onClose={() => setDeviceLogModel(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Select Date Range"}
                </DialogTitle>
                <DialogContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <MDDatePicker
                            label="From"
                            value={dateRange[0]}
                            onChange={(newValue) => setDateRange((prev) => [newValue, prev[1]])}
                            options={{
                                dateFormat: "Y-m-d",
                                maxDate: new Date(),
                            }}
                            input={{ placeholder: "From" }}
                        />
                        <MDDatePicker
                            label="To"
                            value={dateRange[1]}
                            onChange={(newValue) => setDateRange((prev) => [prev[0], newValue])}
                            options={{
                                dateFormat: "Y-m-d",
                                maxDate: new Date(),
                            }}
                            input={{ placeholder: "To" }}
                        />
                    </Stack>
                </DialogContent>
                <DialogContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <MDInput
                            label="Page"
                            type="number"
                            min="1"
                            value={pagin[0]}
                            onChange={(e) => setpagin((prev) => [e.target.value, prev[1]])}
                        />
                        <MDInput
                            label="No. of Page"
                            type="number"
                            min="50"
                            value={pagin[1]}
                            onChange={(e) => setpagin((prev) => [prev[0], e.target.value])}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!dateRange[0] || !dateRange[1] || loader}
                        onClick={handleExport}
                    >
                        <i className="fas fa-file-export"></i>&nbsp; Export
                    </Button>
                </DialogActions>
            </Dialog>
            <Footer />
        </DashboardLayout>
    );
};

export default memo(HolyKelDevice);
